import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";

import Templete from "../../Templete/Templete";
import AuthService from "../../../../services/User/AuthService";
import UtiitslPANCardService from "../../../../services/User/UtiitslPANCardService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";

const PANForm = (props) => {
  const loadingCtx = useContext(LoadingContext);

  const orderId = props.orderId ? props.orderId : props.match.params.orderId;

  const [panData, setPanData] = useState();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async () => {
    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await UtiitslPANCardService.fetchByOrderId(
        token,
        orderId
      );

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        const secret_log1 = JSON.parse(responseData.data.secret_log1);

        setPanData(secret_log1);
        handlePrintAfterDelay();
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  const handlePrintAfterDelay = () => {
    setTimeout(() => {
      window.print();
    }, 2000);
  };

  return (
    <>
      <meta charSet="UTF-8" />
      {panData && (
        <div>
          {/* {JSON.stringify(panData)} */}
          <div
            id="p3"
            style={{
              overflow: "hidden",
              position: "relative",
              backgroundColor: "white",
              width: 909,
              height: 1286,
            }}
          >
            {/* Begin shared CSS values */}
            <style
              className="shared-css"
              type="text/css"
              dangerouslySetInnerHTML={{
                __html:
                  "\n        .t {\n            -webkit-transform-origin: bottom left;\n            -ms-transform-origin: bottom left;\n            transform-origin: bottom left;\n            -webkit-transform: scale(0.25);\n            -ms-transform: scale(0.25);\n            transform: scale(0.25);\n            z-index: 2;\n            position: absolute;\n            white-space: pre;\n            overflow: visible;\n        }\n    ",
              }}
            />
            {/* End shared CSS values */}
            {/* Begin inline CSS */}
            <style
              type="text/css"
              dangerouslySetInnerHTML={{
                __html:
                  "\n        .image-container {\n            position: relative;\n        }\n\n        .image-2 {\n            position: absolute;\n            /*image-rendering: pixelated;*/\n            /*border-radius: 500px;*/\n            /*mix-blend-mode: multiply;*/\n            /*filter: contrast(500%);*/\n\n\n        }\n\n        .image-3 {\n            /*image-rendering: pixelated;*/\n            /*border-radius: 500px;*/\n            /*mix-blend-mode: multiply;*/\n            /*filter: contrast(500%);*/\n        }\n\n        #t1_3 {\n            left: 98px;\n            bottom: 1195px;\n        }\n\n        #t2_3 {\n            left: 82px;\n            bottom: 1185px;\n            letter-spacing: -0.1px;\n        }\n\n        #t3_3 {\n            left: 78px;\n            bottom: 1174px;\n        }\n\n        #t4_3 {\n            left: 83px;\n            bottom: 1163px;\n        }\n\n        #t5_3 {\n            left: 88px;\n            bottom: 1153px;\n        }\n\n        #t6_3 {\n            left: 92px;\n            bottom: 1142px;\n        }\n\n        #t61_3 {\n            left: 40px;\n            bottom: 1100px;\n        }\n\n        #t611_3 {\n            left: 380px;\n            bottom: 1240px;\n            letter-spacing: -0.1px;\n        }\n\n        #t7_3 {\n            left: 793px;\n            bottom: 1197px;\n        }\n\n        #t71_3 {\n            left: 740px;\n            bottom: 1100px;\n        }\n\n        #t8_3 {\n            left: 778px;\n            bottom: 1186px;\n            letter-spacing: -0.1px;\n        }\n\n        #t9_3 {\n            left: 773px;\n            bottom: 1176px;\n        }\n\n        #ta_3 {\n            left: 778px;\n            bottom: 1165px;\n        }\n\n        #tb_3 {\n            left: 783px;\n            bottom: 1155px;\n        }\n\n        #tc_3 {\n            left: 787px;\n            bottom: 1144px;\n        }\n\n        #td_3 {\n            left: 669px;\n            bottom: 996px;\n            word-spacing: -0.2px;\n        }\n\n        #td1_3 {\n            left: 620px;\n            bottom: 1010px;\n        }\n\n        #te_3 {\n            left: 44px;\n            bottom: 1084px;\n        }\n\n        #tf_3 {\n            left: 68px;\n            bottom: 1074px;\n        }\n\n        #tg_3 {\n            left: 405px;\n            bottom: 1234px;\n        }\n\n        #th_3 {\n            left: 272px;\n            bottom: 1218px;\n            word-spacing: -0.6px;\n        }\n\n        #ti_3 {\n            left: 206px;\n            bottom: 1201px;\n        }\n\n        #tj_3 {\n            left: 321px;\n            bottom: 1185px;\n        }\n\n        #tk_3 {\n            left: 407px;\n            bottom: 1171px;\n            letter-spacing: -0.3px;\n            word-spacing: 0.3px;\n        }\n\n        #tl_3 {\n            left: 227px;\n            bottom: 1159px;\n        }\n\n        #tm_3 {\n            left: 198px;\n            bottom: 1133px;\n        }\n\n        #tn_3 {\n            left: 210px;\n            bottom: 1107px;\n        }\n\n        #to_3 {\n            left: 324px;\n            bottom: 1107px;\n        }\n\n        #tp_3 {\n            left: 419px;\n            bottom: 1107px;\n        }\n\n        #tq_3 {\n            left: 540px;\n            bottom: 1107px;\n        }\n\n        #tr_3 {\n            left: 46px;\n            bottom: 1032px;\n            letter-spacing: -0.7px;\n        }\n\n        #ts_3 {\n            left: 46px;\n            bottom: 1011px;\n        }\n\n        #tt_3 {\n            left: 46px;\n            bottom: 995px;\n        }\n\n        #tu_3 {\n            left: 46px;\n            bottom: 971px;\n        }\n\n        #tv_3 {\n            left: 68px;\n            bottom: 971px;\n        }\n\n        #tw_3 {\n            left: 68px;\n            bottom: 946px;\n        }\n\n        #tx_3 {\n            left: 172px;\n            bottom: 940px;\n        }\n\n        #ty_3 {\n            left: 195px;\n            bottom: 946px;\n        }\n\n        #tz_3 {\n            left: 318px;\n            bottom: 946px;\n        }\n\n        #t10_3 {\n            left: 399px;\n            bottom: 946px;\n        }\n\n        #t11_3 {\n            left: 476px;\n            bottom: 946px;\n        }\n\n        #t12_3 {\n            left: 560px;\n            bottom: 946px;\n        }\n\n        #t13_3 {\n            left: 68px;\n            bottom: 920px;\n            letter-spacing: -0.5px;\n        }\n\n        #t14_3 {\n            left: 68px;\n            bottom: 897px;\n        }\n\n        #t15_3 {\n            left: 68px;\n            bottom: 874px;\n        }\n\n        #t16_3 {\n            left: 46px;\n            bottom: 852px;\n        }\n\n        #t17_3 {\n            left: 68px;\n            bottom: 852px;\n            letter-spacing: -0.1px;\n            word-spacing: 0.1px;\n        }\n\n        #t18_3 {\n            left: 46px;\n            bottom: 777px;\n        }\n\n        #t19_3 {\n            left: 68px;\n            bottom: 777px;\n        }\n\n        #t1a_3 {\n            left: 408px;\n            bottom: 777px;\n            letter-spacing: -1.3px;\n        }\n\n        #t1b_3 {\n            left: 494px;\n            bottom: 777px;\n        }\n\n        #t1c_3 {\n            left: 661px;\n            bottom: 777px;\n        }\n\n        #t1d_3 {\n            left: 68px;\n            bottom: 758px;\n        }\n\n        #t1e_3 {\n            left: 68px;\n            bottom: 736px;\n        }\n\n        #t1f_3 {\n            left: 172px;\n            bottom: 731px;\n        }\n\n        #t1g_3 {\n            left: 195px;\n            bottom: 736px;\n        }\n\n        #t1h_3 {\n            left: 318px;\n            bottom: 736px;\n        }\n\n        #t1i_3 {\n            left: 399px;\n            bottom: 736px;\n        }\n\n        #t1j_3 {\n            left: 476px;\n            bottom: 736px;\n        }\n\n        #t1k_3 {\n            left: 560px;\n            bottom: 736px;\n        }\n\n        #t1l_3 {\n            left: 68px;\n            bottom: 710px;\n            letter-spacing: -0.5px;\n        }\n\n        #t1m_3 {\n            left: 68px;\n            bottom: 687px;\n        }\n\n        #t1n_3 {\n            left: 68px;\n            bottom: 665px;\n        }\n\n        #t1o_3 {\n            left: 46px;\n            bottom: 639px;\n        }\n\n        #t1p_3 {\n            left: 68px;\n            bottom: 639px;\n        }\n\n        #t1q_3 {\n            left: 350px;\n            bottom: 639px;\n        }\n\n        #t1r_3 {\n            left: 434px;\n            bottom: 639px;\n        }\n\n        #t1s_3 {\n            left: 534px;\n            bottom: 639px;\n            letter-spacing: -0.3px;\n        }\n\n        #t1t_3 {\n            left: 661px;\n            bottom: 639px;\n        }\n\n        #t1u_3 {\n            left: 46px;\n            bottom: 615px;\n        }\n\n        #t1v_3 {\n            left: 68px;\n            bottom: 615px;\n            word-spacing: -0.1px;\n        }\n\n        #t1w_3 {\n            left: 79px;\n            bottom: 595px;\n        }\n\n        #t1x_3 {\n            left: 138px;\n            bottom: 595px;\n        }\n\n        #t1y_3 {\n            left: 229px;\n            bottom: 595px;\n            letter-spacing: -0.8px;\n        }\n\n        #t1z_3 {\n            left: 46px;\n            bottom: 548px;\n        }\n\n        #t20_3 {\n            left: 68px;\n            bottom: 548px;\n        }\n\n        #t21_3 {\n            left: 68px;\n            bottom: 530px;\n        }\n\n        #t22_3 {\n            left: 92px;\n            bottom: 507px;\n            letter-spacing: -1.5px;\n        }\n\n        #t23_3 {\n            left: 148px;\n            bottom: 507px;\n        }\n\n        #t24_3 {\n            left: 68px;\n            bottom: 489px;\n        }\n\n        #t25_3 {\n            left: 68px;\n            bottom: 472px;\n        }\n\n        #t26_3 {\n            left: 68px;\n            bottom: 449px;\n            letter-spacing: -0.5px;\n        }\n\n        #t27_3 {\n            left: 68px;\n            bottom: 427px;\n        }\n\n        #t28_3 {\n            left: 68px;\n            bottom: 404px;\n        }\n\n        #t29_3 {\n            left: 68px;\n            bottom: 385px;\n        }\n\n        #t2a_3 {\n            left: 68px;\n            bottom: 363px;\n            letter-spacing: -0.5px;\n        }\n\n        #t2b_3 {\n            left: 68px;\n            bottom: 340px;\n        }\n\n        #t2c_3 {\n            left: 68px;\n            bottom: 317px;\n        }\n\n        #t2d_3 {\n            left: 68px;\n            bottom: 298px;\n            letter-spacing: -0.1px;\n            word-spacing: 0.1px;\n        }\n\n        #t2e_3 {\n            left: 550px;\n            bottom: 298px;\n        }\n\n        #t2f_3 {\n            left: 634px;\n            bottom: 298px;\n        }\n\n        #t2g_3 {\n            left: 93px;\n            bottom: 280px;\n            letter-spacing: 0.1px;\n            word-spacing: -0.1px;\n        }\n\n        #t2h_3 {\n            left: 230px;\n            bottom: 280px;\n            letter-spacing: 0.1px;\n            word-spacing: -0.1px;\n        }\n\n        #t2i_3 {\n            left: 352px;\n            bottom: 280px;\n        }\n\n        #t2j_3 {\n            left: 68px;\n            bottom: 258px;\n            letter-spacing: -0.1px;\n            word-spacing: 0.1px;\n        }\n\n        #t2k_3 {\n            left: 68px;\n            bottom: 245px;\n        }\n\n        #t2l_3 {\n            left: 46px;\n            bottom: 224px;\n        }\n\n        #t2m_3 {\n            left: 68px;\n            bottom: 224px;\n        }\n\n        #t2n_3 {\n            left: 68px;\n            bottom: 200px;\n            word-spacing: -1.8px;\n        }\n\n        #t2o_3 {\n            left: 68px;\n            bottom: 180px;\n        }\n\n        #t2p_3 {\n            left: 68px;\n            bottom: 157px;\n        }\n\n        #t2q_3 {\n            left: 68px;\n            bottom: 134px;\n        }\n\n        #t2r_3 {\n            left: 68px;\n            bottom: 111px;\n            letter-spacing: -0.2px;\n        }\n\n        #t2s_3 {\n            left: 68px;\n            bottom: 88px;\n            letter-spacing: -0.3px;\n            word-spacing: 0.3px;\n        }\n\n        #t2t_3 {\n            left: 68px;\n            bottom: 65px;\n            letter-spacing: -0.3px;\n        }\n\n        #t2u_3 {\n            left: 372px;\n            bottom: 65px;\n            word-spacing: -0.1px;\n        }\n\n        #t2v_3 {\n            left: 531px;\n            bottom: 65px;\n        }\n\n        .s1_3 {\n            FONT-SIZE: 42.8px;\n            FONT-FAMILY: ArialMT_n;\n            color: rgb(35, 31, 32);\n        }\n\n        .s2_3 {\n            FONT-SIZE: 42.8px;\n            FONT-FAMILY: ArialMT_v;\n            color: rgb(35, 31, 32);\n        }\n\n        .s3_3 {\n            FONT-SIZE: 36.7px;\n            FONT-FAMILY: ArialMT_v;\n            color: rgb(35, 31, 32);\n        }\n\n        .s4_3 {\n            FONT-SIZE: 36.7px;\n            FONT-FAMILY: Arial-BoldMT_z;\n            color: rgb(35, 31, 32);\n        }\n\n        .s5_3 {\n            FONT-SIZE: 61.1px;\n            FONT-FAMILY: Arial-BoldMT_z;\n            color: rgb(35, 31, 32);\n        }\n\n        .s6_3 {\n            FONT-SIZE: 50.1px;\n            FONT-FAMILY: Arial-BoldMT_z;\n            color: rgb(35, 31, 32);\n        }\n\n        .s7_3 {\n            FONT-SIZE: 42.8px;\n            FONT-FAMILY: Arial-BoldMT_z;\n            color: rgb(35, 31, 32);\n        }\n\n        .s8_3 {\n            FONT-SIZE: 48.9px;\n            FONT-FAMILY: Arial-BoldMT_15;\n            color: rgb(35, 31, 32);\n        }\n\n        .s9_3 {\n            FONT-SIZE: 48.9px;\n            FONT-FAMILY: Arial-BoldMT_z;\n            color: rgb(35, 31, 32);\n        }\n\n        .s10_3 {\n            FONT-SIZE: 48.9px;\n            FONT-FAMILY: ArialMT_v;\n            color: rgb(35, 31, 32);\n        }\n\n        .s11_3 {\n            FONT-SIZE: 85.6px;\n            FONT-FAMILY: Wingdings-Regular_1d;\n            color: rgb(35, 31, 32);\n        }\n\n        .s12_3 {\n            FONT-SIZE: 42.8px;\n            FONT-FAMILY: Arial-BoldMT_15;\n            color: rgb(35, 31, 32);\n        }\n\n        .s13_3 {\n            FONT-SIZE: 48.9px;\n            FONT-FAMILY: Arial-ItalicMT_1l;\n            color: rgb(35, 31, 32);\n        }\n\n        .t.v0_3 {\n            -webkit-transform: scale(0.237, 0.25);\n            -ms-transform: scale(0.237, 0.25);\n            transform: scale(0.237, 0.25);\n        }\n\n        .t.v1_3 {\n            -webkit-transform: scale(0.245, 0.25);\n            -ms-transform: scale(0.245, 0.25);\n            transform: scale(0.245, 0.25);\n        }\n    ",
              }}
            />
            {/* End inline CSS */}
            {/* Begin embedded font definitions */}
            <style
              id="fonts3"
              type="text/css"
              dangerouslySetInnerHTML={{
                __html:
                  '\n        @font-face {\n            font-family: Arial-BoldMT_15;\n            src: url("fonts/Arial-BoldMT_15.woff") format("woff");\n        }\n\n        @font-face {\n            font-family: Arial-BoldMT_z;\n            src: url("fonts/Arial-BoldMT_z.woff") format("woff");\n        }\n\n        @font-face {\n            font-family: Arial-ItalicMT_1l;\n            src: url("fonts/Arial-ItalicMT_1l.woff") format("woff");\n        }\n\n        @font-face {\n            font-family: ArialMT_n;\n            src: url("fonts/ArialMT_n.woff") format("woff");\n        }\n\n        @font-face {\n            font-family: ArialMT_v;\n            src: url("fonts/ArialMT_v.woff") format("woff");\n        }\n\n        @font-face {\n            font-family: Wingdings-Regular_1d;\n            src: url("fonts/Wingdings-Regular_1d.woff") format("woff");\n        }\n\n        input.t[type="text"] {\n            border: none;\n            background: none;\n            font-size: 50px;\n            text-align: center;\n        }\n\n        #custom_align1 input.t[type="text"] {\n            margin-left: -15px;\n        }\n\n\n        .deletebutton {\n            color: white;\n            width: 130px;\n            height: 20px;\n            border-radius: 30px;\n            background-color: #0275d8;\n        }\n\n        .big-input {\n            height: 70px;\n            width: 150px;\n        }\n\n        .little-input {\n            height: 70px;\n            width: 68px;\n        }\n\n        .checkbox-container {\n            display: block;\n            position: absolute;\n            padding-left: 35px;\n            margin-bottom: 12px;\n            cursor: pointer;\n            font-size: 22px;\n            -webkit-user-select: none;\n            -moz-user-select: none;\n            -ms-user-select: none;\n            user-select: none;\n            z-index: 3;\n        }\n\n        /* Hide the browser\'s default checkbox */\n        .checkbox-container input[type="checkbox"] {\n            position: absolute;\n            opacity: 0;\n            cursor: pointer;\n            height: 0;\n            width: 0;\n        }\n\n        /* Create a custom checkbox */\n        .checkmark {\n            position: absolute;\n            top: 0;\n            left: 0;\n            height: 25px;\n            width: 25px;\n            background-color: transparent;\n        }\n\n        /*On mouse-over, add a grey background color*/\n        .checkbox-container:hover input~.checkmark {\n            background-color: transparent;\n        }\n\n        /*When the checkbox is checked, add a blue background*/\n        .checkbox-container input:checked~.checkmark {\n            background-color: transparent;\n        }\n\n        /*Create the checkmark/indicator (hidden when not checked)*/\n        .checkmark:after {\n            content: "";\n            position: absolute;\n            display: none;\n        }\n\n        /*Show the checkmark when checked*/\n        .checkbox-container input:checked~.checkmark:after {\n            display: block;\n        }\n\n        /*Style the checkmark/indicator*/\n        .checkbox-container .checkmark:after {\n            left: 9px;\n            top: 5px;\n            width: 5px;\n            height: 10px;\n            border: solid black;\n            border-width: 0 3px 3px 0;\n            -webkit-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: rotate(45deg);\n        }\n    ',
              }}
            />
            {/* End embedded font definitions */}
            {/* Begin page background */}
            <div
              id="pg3Overlay"
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                zIndex: 1,
                backgroundColor: "rgba(0,0,0,0)",
                WebkitUserSelect: "none",
              }}
            ></div>
            <img
              id="pg3"
              style={{ WebkitUserSelect: "none", width: 909, height: 1286 }}
              src="https://i.ibb.co/DksG5PX/page1.png"
            />
            {/* End page background */}
            {/*<input type="checkbox" class="title" style="position: absolute;bottom: 732px;left: 293px;font-size: 50px;width: 22px;height: 22px;">
      <input type="checkbox"  class="title" style="position: absolute;bottom: 732px;left: 374px;font-size: 50px;width: 22px;height: 22px;">
      <input type="checkbox" class="title" style="position: absolute;bottom: 732px;left: 451px;font-size: 50px;width: 22px;height: 22px;">
      <input type="checkbox"  class="title" style="position: absolute;bottom: 732px;left: 535px;font-size: 50px;width: 22px;height: 22px;">



      <input type="checkbox"  style="position: absolute;bottom: 772px;left: 379px;font-size: 50px;width: 22px;height: 22px;">
      <input type="checkbox" checked style="position: absolute;bottom: 772px;left: 466px;font-size: 50px;width: 22px;height: 22px;">


      <input type="checkbox"  style="position: absolute;bottom: 635px;left: 322px;font-size: 50px;width: 22px;height: 22px;">
      <input type="checkbox"  style="position: absolute;bottom: 635px;left: 407px;font-size: 50px;width: 22px;height: 22px;">
      <input type="checkbox"  style="position: absolute;bottom: 635px;left: 505px;font-size: 50px;width: 22px;height: 22px;">



      <input type="checkbox"  style="position: absolute;bottom: 505px;left: 68px;font-size: 50px;width: 22px;height: 22px;">
      <input type="checkbox"  style="position: absolute;bottom: 505px;left: 123px;font-size: 50px;width: 22px;height: 22px;">

      

      <input type="checkbox"  style="position: absolute;bottom: 276px;left: 68px;font-size: 50px;width: 22px;height: 22px;">
      <input type="checkbox"  style="position: absolute;bottom: 276px;left: 205px;font-size: 50px;width: 22px;height: 22px;">*/}

            <input
              type="text"
              className="t little-input dob day"
              style={{ left: 69, bottom: 571 }}
              defaultValue={panData?.dobString?.split("")[8] || ""}
            />
            <input
              type="text"
              className="t little-input dob day"
              style={{ left: 89, bottom: 571 }}
              defaultValue={panData?.dobString?.split("")[9] || ""}
            />
            <input
              type="text"
              className="t little-input dob month"
              style={{ left: 134, bottom: 571 }}
              defaultValue={panData?.dobString?.split("")[5] || ""}
            />
            <input
              type="text"
              className="t little-input dob month"
              style={{ left: 156, bottom: 571 }}
              defaultValue={panData?.dobString?.split("")[6] || ""}
            />
            <input
              type="text"
              className="t little-input dob year"
              style={{ left: 199, bottom: 571 }}
              defaultValue={panData?.dobString?.split("")[0] || ""}
            />
            <input
              type="text"
              className="t little-input dob year"
              style={{ left: 220, bottom: 571 }}
              defaultValue={panData?.dobString?.split("")[1] || ""}
            />
            <input
              type="text"
              className="t little-input dob year"
              style={{ left: 242, bottom: 571 }}
              defaultValue={panData?.dobString?.split("")[2] || ""}
            />
            <input
              type="text"
              className="t little-input dob year"
              style={{ left: 264, bottom: 571 }}
              defaultValue={panData?.dobString?.split("")[3] || ""}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 372, bottom: 206 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 394, bottom: 206 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 416, bottom: 206 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 437, bottom: 206 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 460, bottom: 206 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 482, bottom: 206 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 504, bottom: 206 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 376, bottom: 19 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 398, bottom: 19 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 420, bottom: 19 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 442, bottom: 19 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 464, bottom: 19 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 486, bottom: 19 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 508, bottom: 19 }}
            />
            {/*Area code*/}
            <input
              type="text"
              id="top_area_code1"
              className="t big-input top_area_code"
              style={{ left: 179, bottom: 1080 }}
            />
            <input
              type="text"
              id="top_area_code2"
              className="t big-input top_area_code"
              style={{ left: 222, bottom: 1080 }}
            />
            <input
              type="text"
              id="top_area_code3"
              className="t big-input top_area_code"
              style={{ left: 265, bottom: 1080 }}
            />
            {/*AO type*/}
            <input
              type="text"
              id="top_ao_type1"
              className="t big-input top_ao_type"
              style={{ left: 306, bottom: 1080 }}
            />
            <input
              type="text"
              id="top_ao_type2"
              className="t big-input top_ao_type"
              style={{ left: 348, bottom: 1080 }}
            />
            {/*Range code */}
            <input
              type="text"
              id="top_range_code1"
              className="t big-input top_range_code"
              style={{ left: 392, bottom: 1080 }}
            />
            <input
              type="text"
              id="top_range_code2"
              className="t big-input top_range_code"
              style={{ left: 436, bottom: 1080 }}
            />
            <input
              type="text"
              id="top_range_code3"
              className="t big-input top_range_code"
              style={{ left: 476, bottom: 1080 }}
            />
            {/*AO No */}
            <input
              type="text"
              id="top_ao_no1"
              className="t big-input top_ao_no"
              style={{ left: 519, bottom: 1080 }}
            />
            <input
              type="text"
              id="top_ao_no2"
              className="t big-input top_ao_no"
              style={{ left: 562, bottom: 1080 }}
            />
            {/*Last Name / Surname*/}
            {panData.lastName?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="last_name"
                  className="t little-input last_name"
                  style={{ left: `${295 + index * 22}px`, bottom: 921 }}
                  defaultValue={value}
                />
              </div>
            ))}

            {/*User Title*/}

            {panData.nameTitle == "1" && (
              <input
                type="checkbox"
                checked={true}
                style={{
                  position: "absolute",
                  bottom: 940,
                  left: 290,
                  fontSize: 50,
                  width: 19,
                  height: 19,
                }}
              />
            )}

            {panData.nameTitle == "2" && (
              <input
                type="checkbox"
                style={{
                  position: "absolute",
                  bottom: 940,
                  left: 371,
                  fontSize: 50,
                  width: 19,
                  height: 19,
                }}
              />
            )}
            {panData.nameTitle == "3" && (
              <input
                type="checkbox"
                style={{
                  position: "absolute",
                  bottom: 940,
                  left: 448,
                  fontSize: 50,
                  width: 19,
                  height: 19,
                }}
              />
            )}

            <div
              id="title1"
              data-selectedvalue="S"
              className="t little-input title"
              style={{ left: 295, bottom: 944, fontSize: 65 }}
            />
            <div
              id="title2"
              data-selectedvalue="T"
              className="t little-input title"
              style={{ left: 376, bottom: 944, fontSize: 65 }}
            />
            <div
              id="title3"
              data-selectedvalue="K"
              className="t little-input title"
              style={{ left: 453, bottom: 944, fontSize: 65 }}
            />
            <div
              id="title4"
              data-selectedvalue="M"
              className="t little-input title"
              style={{ left: 537, bottom: 944, fontSize: 65 }}
            />
            {/*First Name*/}
            {panData.firstName?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="first_name"
                  className="t little-input first_name"
                  style={{ left: `${295 + index * 22}px`, bottom: 896 }}
                  defaultValue={value}
                />
              </div>
            ))}

            {/*middle_name*/}
            {panData.middleName?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="middle_name"
                  className="t little-input middle_name"
                  style={{ left: `${295 + index * 22}px`, bottom: 872 }}
                  defaultValue={value}
                />
              </div>
            ))}

            {/*full_name*/}
            {panData.panName?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="full_name"
                  className="t little-input full_name"
                  style={{ left: `${69 + index * 22}px`, bottom: 824 }}
                  defaultValue={value}
                />
              </div>
            ))}

            {/*Have you ever been known by any other name*/}

            <label
              className="checkbox-container"
              style={{ left: 464, bottom: 783, fontSize: 65 }}
            >
              <input type="checkbox" checked={true} />
              <span className="checkmark" />
            </label>

            <div
              id="has_alias1"
              data-selectedvalue="Y"
              className="t little-input has_alias"
              style={{ left: 382, bottom: 775, fontSize: 65 }}
            />
            <div
              id="has_alias2"
              data-selectedvalue="N"
              className="t little-input has_alias"
              style={{ left: 468, bottom: 775, fontSize: 65 }}
            />
            <label
              className="checkbox-container"
              style={{ left: 464, bottom: 783, fontSize: 65 }}
            >
              <input type="checkbox" defaultChecked="" />
              <span className="checkmark" />
            </label>
            {/*User Title*/}
            <div
              id="alt_title1"
              data-selectedvalue="S"
              className="t little-input alt_title"
              style={{ left: 295, bottom: 735, fontSize: 65 }}
            />
            <div
              id="alt_title2"
              data-selectedvalue="T"
              className="t little-input alt_title"
              style={{ left: 376, bottom: 735, fontSize: 65 }}
            />
            <div
              id="alt_title3"
              data-selectedvalue="K"
              className="t little-input alt_title"
              style={{ left: 453, bottom: 735, fontSize: 65 }}
            />
            <div
              id="alt_title4"
              data-selectedvalue="M"
              className="t little-input alt_title"
              style={{ left: 537, bottom: 735, fontSize: 65 }}
            />
            {/* another name pause alt_last_name */}
            <input
              type="text"
              className="t little-input alt_last_name "
              style={{ left: 295, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 316, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 337, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 359, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 380, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 402, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 424, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 445, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 467, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 489, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 510, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 532, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 554, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 575, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 597, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 619, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 640, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 662, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 683, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 705, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 727, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 748, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 770, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 792, bottom: 710 }}
            />
            <input
              type="text"
              className="t little-input alt_last_name"
              style={{ left: 813, bottom: 710 }}
            />
            {/* another name pause alt_first_name */}
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 295, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 316, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 337, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 359, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 380, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 402, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 424, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 445, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 467, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 489, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 510, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 532, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 554, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 575, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 597, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 619, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 640, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 662, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 683, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 705, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 727, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 748, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 770, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 792, bottom: 687 }}
            />
            <input
              type="text"
              className="t little-input alt_first_name"
              style={{ left: 813, bottom: 687 }}
            />
            <input
              type="checkbox"
              style={{
                position: "absolute",
                bottom: 503,
                left: 65,
                fontSize: 50,
                width: 19,
                height: 19,
              }}
            />
            <input
              type="checkbox"
              style={{
                position: "absolute",
                bottom: 503,
                left: 120,
                fontSize: 50,
                width: 19,
                height: 19,
              }}
            />
            {/* another name pause alt_middle_name */}
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 295, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 316, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 337, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 359, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 380, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 402, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 424, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 445, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 467, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 489, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 510, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 532, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 554, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 575, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 597, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 619, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 640, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 662, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 683, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 705, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 727, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 748, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 770, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 792, bottom: 664 }}
            />
            <input
              type="text"
              className="t little-input alt_middle_name"
              style={{ left: 813, bottom: 664 }}
            />
            {/*Gender (for Individual applicants only)*/}

            {panData.gender == "M" && (
              <input
                type="checkbox"
                checked={true}
                style={{
                  position: "absolute",
                  bottom: 633,
                  left: 320,
                  fontSize: 50,
                  width: 19,
                  height: 19,
                }}
                imageName="2/form/195 0 R"
                images="110100"
              />
            )}

            {panData.gender == "F" && (
              <input
                type="checkbox"
                checked={true}
                style={{
                  position: "absolute",
                  bottom: 633,
                  left: 404,
                  fontSize: 50,
                  width: 19,
                  height: 19,
                }}
                imageName="2/form/195 0 R"
                images="110100"
              />
            )}

            <div
              id="gender1"
              data-selectedvalue="M"
              className="t little-input gender"
              style={{ left: 324, bottom: 639, fontSize: 65 }}
            />
            <div
              id="gender2"
              data-selectedvalue="F"
              className="t little-input gender"
              style={{ left: 409, bottom: 639, fontSize: 65 }}
            />
            <div
              id="gender3"
              data-selectedvalue="T"
              className="t little-input gender"
              style={{ left: 508, bottom: 639, fontSize: 65 }}
            />
            {/*Whether mother is a single parent and you wish to apply for PAN by furnishing the name of your mother only?*/}

            <input
              type="checkbox"
              checked={true}
              style={{
                position: "absolute",
                bottom: 274,
                left: 65,
                fontSize: 50,
                width: 19,
                height: 19,
              }}
            />

            <div
              id="pan_mother_only1"
              data-selectedvalue="Y"
              className="t little-input pan_mother_only"
              style={{ left: 71, bottom: 508, fontSize: 65 }}
            ></div>
            <p
              style={{
                position: "relative",
                left: 125,
                bottom: 530,
                fontSize: 20,
              }}
            >
              {" "}
              ✓{" "}
            </p>
            <div
              id="pan_mother_only2"
              data-selectedvalue="N"
              className="t little-input pan_mother_only"
              style={{ left: 125, bottom: 508, fontSize: 65 }}
            />
            {/*Select the name of either father or mother which you may like to be printed on PAN card (Select one only)*/}
            <div
              id="parent_name_oncard1"
              data-selectedvalue="F"
              className="t little-input parent_name_oncard"
              style={{ left: 71, bottom: 279, fontSize: 65 }}
            />
            <div
              id="parent_name_oncard2"
              data-selectedvalue="M"
              className="t little-input parent_name_oncard"
              style={{ left: 208, bottom: 279, fontSize: 65 }}
            />
            {/*Details of Parents (applicable only for Individual applicants)*/}
            {/* another name pause father_last_name */}
            {panData.fthLast?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="father_last_name"
                  className="t little-input father_last_name"
                  style={{ left: `${295 + index * 22}px`, bottom: 450 }}
                  defaultValue={value}
                />
              </div>
            ))}

            {/* another name pause father_first_name */}
            {panData.fthFirst?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="father_first_name"
                  className="t little-input father_first_name"
                  style={{ left: `${295 + index * 22}px`, bottom: 428 }}
                  defaultValue={value}
                />
              </div>
            ))}

            {/* another name pause father_middle_name */}
            {panData.fthMiddle?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="father_middle_name"
                  className="t little-input father_middle_name"
                  style={{ left: `${295 + index * 22}px`, bottom: 405 }}
                  defaultValue={value}
                />
              </div>
            ))}

            {/*Mother's Name (optional except where mother is a single parent and PAN is applied by furnishing the name of mother only*/}
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 295, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 316, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 337, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 359, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 380, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 402, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 424, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 445, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 467, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 489, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 510, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 532, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 554, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 575, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 597, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 619, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 640, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 662, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 683, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 705, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 727, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 748, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 770, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 792, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_last_name"
              style={{ left: 813, bottom: 365 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 295, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 316, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 337, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 359, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 380, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 402, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 424, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 445, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 467, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 489, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 510, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 532, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 554, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 575, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 597, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 619, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 640, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 662, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 683, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 705, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 727, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 748, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 770, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 792, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_first_name"
              style={{ left: 813, bottom: 341 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 295, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 316, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 337, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 359, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 380, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 402, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 424, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 445, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 467, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 489, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 510, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 532, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 554, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 575, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 597, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 619, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 640, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 662, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 683, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 705, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 727, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 748, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 770, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 792, bottom: 317 }}
            />
            <input
              type="text"
              className="t little-input mother_middle_name"
              style={{ left: 813, bottom: 317 }}
            />
            {/*Flat / Room / Door / Block No*/}
            {panData.resAddr1?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="res_door_no"
                  className="t little-input res_door_no"
                  style={{ left: `${295 + index * 22}px`, bottom: 180 }}
                  defaultValue={value}
                />
              </div>
            ))}

            {panData.resAddr2?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="res_building_name"
                  className="t little-input res_building_name"
                  style={{ left: `${295 + index * 22}px`, bottom: 157 }}
                  defaultValue={value}
                />
              </div>
            ))}

            {panData.resAddr3?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="res_road_name"
                  className="t little-input res_road_name"
                  style={{ left: `${295 + index * 22}px`, bottom: 133 }}
                  defaultValue={value}
                />
              </div>
            ))}

            {panData.resAddr4?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="res_area_name"
                  className="t little-input res_area_name"
                  style={{ left: `${295 + index * 22}px`, bottom: 111 }}
                  defaultValue={value}
                />
              </div>
            ))}

            {panData.resDist?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="res_town_name"
                  className="t little-input res_town_name"
                  style={{ left: `${295 + index * 22}px`, bottom: 90 }}
                  defaultValue={value}
                />
              </div>
            ))}

            {/*State / Union Territory*/}
            <input
              type="text"
              className="t little-input res_state_name"
              style={{ left: 73, bottom: 43, width: 1172 }}
              value={panData.state}
            />

            {panData.resPin?.split("").map((value, index) => (
              <div key={index}>
                <input
                  type="text"
                  id="res_pincode"
                  className="t little-input res_pincode"
                  style={{ left: `${372 + index * 22}px`, bottom: 43 }}
                  defaultValue={value}
                />
              </div>
            ))}

            <input
              type="text"
              className="t little-input res_country"
              style={{ left: 510, bottom: 43, width: 1172 }}
              value="INDIA"
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 155, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 315, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 337, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 359, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 380, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 402, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 424, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 445, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 467, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 489, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 510, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 532, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 554, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 575, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 597, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 569, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 640, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 662, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 684, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 664, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 727, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 749, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 770, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 792, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 814, bottom: 254 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 155, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 315, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 337, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 359, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 380, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 402, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 424, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 445, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 467, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 489, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 510, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 532, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 554, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 575, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 597, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 569, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 640, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 662, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 684, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 664, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 727, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 749, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 770, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 792, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 814, bottom: 168 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 155, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 315, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 337, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 359, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 380, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 402, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 424, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 445, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 467, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 489, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 510, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 532, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 554, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 575, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 597, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 569, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 640, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 662, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 684, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 664, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 727, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 749, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 770, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 792, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 814, bottom: 147 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 155, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 315, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 337, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 359, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 380, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 402, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 424, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 445, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 467, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 489, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 510, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 532, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 554, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 575, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 597, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 569, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 640, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 662, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 684, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 664, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 727, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 749, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 770, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 792, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 814, bottom: 126 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 155, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 315, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 337, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 359, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 380, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 402, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 424, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 445, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 467, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 489, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 510, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 532, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 554, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 575, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 597, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 569, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 640, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 662, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 684, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 664, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 727, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 749, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 770, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 792, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 814, bottom: 105 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 155, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 315, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 337, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 359, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 380, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 402, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 424, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 445, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 467, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 489, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 510, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 532, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 554, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 575, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 597, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 569, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 640, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 662, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 684, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 664, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 727, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 749, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 770, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 792, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 814, bottom: 84 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 155, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 315, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 337, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 359, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 380, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 402, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 424, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 445, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 467, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 489, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 510, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 532, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 554, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 575, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 597, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 569, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 640, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 662, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 663, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 664, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 727, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 749, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 770, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 792, bottom: 63 }}
            />
            <input
              type="text"
              className="t little-input"
              style={{ left: 814, bottom: 63 }}
            />
            {/* Begin text definitions (Positioned/styled in CSS) */}
            {/*<div id="t1_3" class="t v0_3 s1_3">Only </div>*/}
            {/*<div id="t2_3" class="t v0_3 s1_3">'Individuals' </div>*/}
            {/*<div id="t3_3" class="t v0_3 s2_3">to af?x recent </div>*/}
            {/*<div id="t4_3" class="t v0_3 s2_3">photograph</div>*/}
            {/*<div id="t5_3" class="t v0_3 s2_3">(3.5 cm x</div>*/}
            {/*<div id="t6_3" class="t v0_3 s2_3">2.5 cm)</div>*/}
            <div id="t611_3" className="t s9_1"></div>
            <div id="t61_3" className="t v0_3 s2_3 image-container">
              {/* <img
                src=""
                id="image-1"
                width="512px"
                height="600px"
                //  alt="photo"
              /> */}
              {/* <img
                src=""
                className="image-2"
                id="sign-1"
                width="900px"
                height="300px"
                style={{ left: 200, top: 150 }}
                onclick=""
                //alt="signature"
              /> */}
            </div>
            {/*<div id="t7_3" class="t v0_3 s1_3">Only </div>*/}
            {/*<div id="t8_3" class="t v0_3 s1_3">'Individuals' </div>*/}
            {/*<div id="t9_3" class="t v0_3 s2_3">to af?x recent </div>*/}
            {/*<div id="ta_3" class="t v0_3 s2_3">photograph</div>*/}
            {/*<div id="tb_3" class="t v0_3 s2_3">(3.5 cm x </div>*/}
            {/*<div id="tc_3" class="t v0_3 s2_3">2.5 cm)</div>*/}
            <div id="t71_3" className="t v0_3 s1_3">
              {/* <img
                src=""
                id="image-2"
                width="512px"
                height="600px"
                style={{ right: 2, top: 4 }}
                //  alt="photo"
              /> */}
            </div>
            {/*<div id="td_3" class="t s3_3">Signature / Left Thumb Impression</div>*/}
            <div id="td1_3" className="t s3_3">
              {/* <img
                src=""
                id="sign-1"
                className="image-3"
                width="900px"
                height="300px"
                style={{ right: 2, top: 4 }}
                onclick=""
                //  alt="photo"
              /> */}
            </div>
            <div id="te_3" className="t v0_3 s4_3">
              Sign / Left Thumb impression
            </div>
            <div id="tf_3" className="t v0_3 s4_3">
              across this photo
            </div>
            <div id="tg_3" className="t s5_3">
              Form No. 49A
            </div>
            <div id="th_3" className="t s6_3">
              Application for Allotment of Permanent Account Number{" "}
            </div>
            <div id="ti_3" className="t s6_3">
              [In the case of Indian Citizens/lndian Companies/Entities
              incorporated in India/
            </div>
            <div id="tj_3" className="t s6_3">
              Unincorporated entities formed in India]
            </div>
            <div id="tk_3" className="t s7_3">
              See Rule 114
            </div>
            <div id="tl_3" className="t s3_3">
              To avoid mistake (s), please follow the accompanying instructions
              and examples before ?lling up the form
            </div>
            <div id="tm_3" className="t s8_3">
              Assessing of?cer (AO code)
            </div>
            <div id="tn_3" className="t s9_3">
              Area code
            </div>
            <div id="to_3" className="t s8_3">
              AO type
            </div>
            <div id="tp_3" className="t s9_3">
              Range code
            </div>
            <div id="tq_3" className="t s8_3">
              AO No.
            </div>
            <div id="tr_3" className="t s10_3">
              Sir,{" "}
            </div>
            <div id="ts_3" className="t s10_3">
              I/We hereby request that a permanent account number be allotted to
              me/us.{" "}
            </div>
            <div id="tt_3" className="t s10_3">
              I/We give below necessary particulars:
            </div>
            <div id="tu_3" className="t s9_3">
              1{" "}
            </div>
            <div id="tv_3" className="t v1_3 s8_3">
              Full Name (Full expanded name to be mentioned as appearing in
              proof of identity/date of birth/address documents: initials are
              not permitted)
            </div>
            <div id="tw_3" className="t s10_3">
              Please select title,
            </div>
            <div id="tx_3" className="t s11_3">
              ✓
            </div>
            <div id="ty_3" className="t s10_3">
              as applicable
            </div>
            <div id="tz_3" className="t s10_3">
              Shri
            </div>
            <div id="t10_3" className="t s10_3">
              Smt.
            </div>
            <div id="t11_3" className="t s10_3">
              Kumari
            </div>
            <div id="t12_3" className="t s10_3">
              M/s
            </div>
            <div id="t13_3" className="t s10_3">
              Last Name / Surname
            </div>
            <div id="t14_3" className="t s10_3">
              First Name
            </div>
            <div id="t15_3" className="t s10_3">
              Middle Name
            </div>
            <div id="t16_3" className="t s8_3">
              2{" "}
            </div>
            <div id="t17_3" className="t s8_3">
              Abbreviations of the above name, as you would like it, to be
              printed on the PAN card
            </div>
            <div id="t18_3" className="t s8_3">
              3{" "}
            </div>
            <div id="t19_3" className="t s8_3">
              Have you ever been known by any other name?
            </div>
            <div id="t1a_3" className="t s9_3">
              Yes
            </div>
            <div id="t1b_3" className="t s9_3">
              No
            </div>
            <div id="t1c_3" className="t s8_3">
              (please tick as applicable)
            </div>
            <div id="t1d_3" className="t s2_3">
              If yes, please give that other name
            </div>
            <div id="t1e_3" className="t s10_3">
              Please select title,
            </div>
            <div id="t1f_3" className="t s11_3">
              ✓
            </div>
            <div id="t1g_3" className="t s10_3">
              as applicable
            </div>
            <div id="t1h_3" className="t s10_3">
              Shri
            </div>
            <div id="t1i_3" className="t s10_3">
              Smt.
            </div>
            <div id="t1j_3" className="t s10_3">
              Kumari
            </div>
            <div id="t1k_3" className="t s10_3">
              M/s
            </div>
            <div id="t1l_3" className="t s10_3">
              Last Name / Surname
            </div>
            <div id="t1m_3" className="t s10_3">
              First Name
            </div>
            <div id="t1n_3" className="t s10_3">
              Middle Name
            </div>
            <div id="t1o_3" className="t s8_3">
              4{" "}
            </div>
            <div id="t1p_3" className="t s8_3">
              Gender (for Individual applicants only)
            </div>

            <div id="t1q_3" className="t s9_3">
              Male
            </div>
            <div id="t1r_3" className="t s9_3">
              Female
            </div>
            <div id="t1s_3" className="t s9_3">
              Transgender
            </div>
            <div id="t1t_3" className="t s8_3">
              (please tick as applicable)
            </div>
            <div id="t1u_3" className="t s8_3">
              5{" "}
            </div>
            <div id="t1v_3" className="t s8_3">
              Date of Birth/Incorporation/Agreement/Partnership or Trust Deed/
              Formation of Body of individuals or Association of Persons
            </div>
            <div id="t1w_3" className="t s12_3">
              Day{" "}
            </div>
            <div id="t1x_3" className="t s12_3">
              Month{" "}
            </div>
            <div id="t1y_3" className="t s12_3">
              Year
            </div>
            <div id="t1z_3" className="t s8_3">
              6{" "}
            </div>
            <div id="t20_3" className="t s8_3">
              Details of Parents (applicable only for individual applicants)
            </div>
            <div id="t21_3" className="t s10_3">
              Whether mother is a single parent and you wish to apply for PAN by
              furnishing the name of your mother only?{" "}
            </div>
            <div id="t22_3" className="t s10_3">
              Yes{" "}
            </div>
            <div id="t23_3" className="t s10_3">
              No (please tick as applicable)
            </div>
            <div id="t24_3" className="t s10_3">
              If yes, please ?ll in mother's name in the appropriate space
              provide below.
            </div>
            <div id="t25_3" className="t s8_3">
              Father's Name (Mandatory except where mother is a single parent
              and PAN is applied by furnishing the name of mother only)
            </div>
            <div id="t26_3" className="t s10_3">
              Last Name / Surname
            </div>
            <div id="t27_3" className="t s10_3">
              First Name
            </div>
            <div id="t28_3" className="t s10_3">
              Middle Name
            </div>
            <div id="t29_3" className="t s8_3">
              Mother's Name (optional except where mother is a single parent and
              PAN is applied by furnishing the name of mother only)
            </div>
            <div id="t2a_3" className="t s10_3">
              Last Name / Surname
            </div>
            <div id="t2b_3" className="t s10_3">
              First Name
            </div>
            <div id="t2c_3" className="t s10_3">
              Middle Name
            </div>
            <div id="t2d_3" className="t s10_3">
              Select the name of either father or mother which you may like to
              be printed on PAN card (
            </div>
            <div id="t2e_3" className="t s13_3">
              Select one only
            </div>
            <div id="t2f_3" className="t s10_3">
              )
            </div>
            <div id="t2g_3" className="t s10_3">
              Father's name
            </div>
            <div id="t2h_3" className="t s10_3">
              Mother's name{" "}
            </div>
            <div id="t2i_3" className="t s13_3">
              (Please tick as applicable)
            </div>
            <div id="t2j_3" className="t s10_3">
              (In case no option is provided then PAN card will be issued with
              father's name except where mother is a single parent and you wish
              to apply for PAN{" "}
            </div>
            <div id="t2k_3" className="t s10_3">
              by furnishing name of the mother only)'.
            </div>
            <div id="t2l_3" className="t s9_3">
              7{" "}
            </div>
            <div id="t2m_3" className="t s9_3">
              Address
            </div>
            <div id="t2n_3" className="t s9_3">
              Residence Address
            </div>
            <div id="t2o_3" className="t v0_3 s10_3">
              Flat / Room / Door / Block No.
            </div>
            <div id="t2p_3" className="t v0_3 s10_3">
              Name of Premises / Building / Village
            </div>
            <div id="t2q_3" className="t v0_3 s10_3">
              Road / Street / Lane/Post Of?ce{" "}
            </div>
            <div id="t2r_3" className="t v0_3 s10_3">
              Area / Locality / Taluka/ Sub- Division
            </div>
            <div id="t2s_3" className="t v0_3 s10_3">
              Town / City / District
            </div>
            <div id="t2t_3" className="t s10_3">
              State / Union Territory{" "}
            </div>
            <div id="t2u_3" className="t s10_3">
              Pincode / Zip code{" "}
            </div>
            <div id="t2v_3" className="t s10_3">
              Country Name
            </div>
            {/* End text definitions */}
          </div>
          <div
            id="p2"
            className="pageArea"
            style={{
              overflow: "hidden",
              position: "relative",
              width: 909,
              height: 1286,
              marginTop: 20,
              backgroundColor: "white",
            }}
          >
            {/* Begin shared CSS values */}
            <style
              className="shared-css"
              type="text/css"
              dangerouslySetInnerHTML={{
                __html:
                  "\n        .t {\n            -webkit-transform-origin: bottom left;\n            -ms-transform-origin: bottom left;\n            transform-origin: bottom left;\n            -webkit-transform: scale(0.25);\n            -ms-transform: scale(0.25);\n            transform: scale(0.25);\n            z-index: 2;\n            position: absolute;\n            white-space: pre;\n            overflow: visible;\n        }\n\n        div#p2 input.t {\n            margin-left: 5px;\n        }\n    ",
              }}
            />
            {/* End shared CSS values */}
            {/* Begin inline CSS */}
            <style
              type="text/css"
              dangerouslySetInnerHTML={{
                __html:
                  "\n        #lastone {\n            top: 1249px;\n            font-size: 13px;\n            left: 75px;\n            background: lavender;\n            position: absolute;\n            word-spacing: -0.2px;\n        }\n\n        #t1_2 {\n            left: 644px;\n            bottom: 56px;\n            word-spacing: -0.2px;\n        }\n\n        #t111_2 {\n            left: 644px;\n            bottom: 72px;\n        }\n\n        #t2_2 {\n            left: 672px;\n            bottom: 43px;\n        }\n\n        #t3_2 {\n            left: 67px;\n            bottom: 1236px;\n            word-spacing: -1.8px;\n        }\n\n        #t4_2 {\n            left: 67px;\n            bottom: 1219px;\n        }\n\n        #t5_2 {\n            left: 67px;\n            bottom: 1198px;\n        }\n\n        #t6_2 {\n            left: 67px;\n            bottom: 1176px;\n        }\n\n        #t7_2 {\n            left: 67px;\n            bottom: 1155px;\n        }\n\n        #t8_2 {\n            left: 67px;\n            bottom: 1134px;\n            letter-spacing: -0.2px;\n        }\n\n        #t9_2 {\n            left: 67px;\n            bottom: 1112px;\n            letter-spacing: -0.3px;\n            word-spacing: 0.3px;\n        }\n\n        #ta_2 {\n            left: 67px;\n            bottom: 1095px;\n            letter-spacing: -0.3px;\n        }\n\n        #tb_2 {\n            left: 372px;\n            bottom: 1095px;\n            word-spacing: -0.1px;\n        }\n\n        #tc_2 {\n            left: 535px;\n            bottom: 1095px;\n        }\n\n        #td_2 {\n            left: 46px;\n            bottom: 1047px;\n        }\n\n        #te_2 {\n            left: 67px;\n            bottom: 1047px;\n        }\n\n        #tf_2 {\n            left: 403px;\n            bottom: 1047px;\n        }\n\n        #tg_2 {\n            left: 566px;\n            bottom: 1047px;\n        }\n\n        #th_2 {\n            left: 669px;\n            bottom: 1047px;\n        }\n\n        #ti_2 {\n            left: 46px;\n            bottom: 1026px;\n        }\n\n        #tj_2 {\n            left: 67px;\n            bottom: 1026px;\n            letter-spacing: -0.1px;\n            word-spacing: 0.1px;\n        }\n\n        #tk_2 {\n            left: 129px;\n            bottom: 1008px;\n        }\n\n        #tl_2 {\n            left: 219px;\n            bottom: 1008px;\n        }\n\n        #tm_2 {\n            left: 393px;\n            bottom: 1008px;\n            letter-spacing: -0.3px;\n            word-spacing: 0.3px;\n        }\n\n        #tn_2 {\n            left: 67px;\n            bottom: 965px;\n        }\n\n        #to_2 {\n            left: 46px;\n            bottom: 940px;\n            word-spacing: 6.2px;\n        }\n\n        #tp_2 {\n            left: 67px;\n            bottom: 918px;\n        }\n\n        #tq_2 {\n            left: 189px;\n            bottom: 912px;\n        }\n\n        #tr_2 {\n            left: 211px;\n            bottom: 918px;\n        }\n\n        #ts_2 {\n            left: 721px;\n            bottom: 915px;\n        }\n\n        #tt_2 {\n            left: 93px;\n            bottom: 891px;\n        }\n\n        #tu_2 {\n            left: 210px;\n            bottom: 891px;\n        }\n\n        #tv_2 {\n            left: 384px;\n            bottom: 891px;\n        }\n\n        #tw_2 {\n            left: 535px;\n            bottom: 891px;\n        }\n\n        #tx_2 {\n            left: 721px;\n            bottom: 891px;\n        }\n\n        #ty_2 {\n            left: 93px;\n            bottom: 867px;\n            letter-spacing: -0.4px;\n        }\n\n        #tz_2 {\n            left: 210px;\n            bottom: 867px;\n        }\n\n        #t10_2 {\n            left: 384px;\n            bottom: 867px;\n            word-spacing: -2.7px;\n        }\n\n        #t11_2 {\n            left: 535px;\n            bottom: 867px;\n        }\n\n        #t12_2 {\n            left: 721px;\n            bottom: 867px;\n        }\n\n        #t13_2 {\n            left: 46px;\n            bottom: 846px;\n            letter-spacing: -0.1px;\n            word-spacing: 3.2px;\n        }\n\n        #t14_2 {\n            left: 46px;\n            bottom: 800px;\n        }\n\n        #t15_2 {\n            left: 67px;\n            bottom: 800px;\n            word-spacing: -0.2px;\n        }\n\n        #t16_2 {\n            left: 67px;\n            bottom: 779px;\n            word-spacing: -0.4px;\n        }\n\n        #t17_2 {\n            left: 67px;\n            bottom: 761px;\n            word-spacing: -0.4px;\n        }\n\n        #t18_2 {\n            left: 67px;\n            bottom: 724px;\n            word-spacing: -0.3px;\n        }\n\n        #t19_2 {\n            left: 46px;\n            bottom: 640px;\n        }\n\n        #t1a_2 {\n            left: 76px;\n            bottom: 640px;\n        }\n\n        #t1b_2 {\n            left: 678px;\n            bottom: 640px;\n        }\n\n        #t1c_2 {\n            left: 764px;\n            bottom: 634px;\n        }\n\n        #t1d_2 {\n            left: 790px;\n            bottom: 640px;\n        }\n\n        #t1e_2 {\n            left: 76px;\n            bottom: 612px;\n        }\n\n        #t1f_2 {\n            left: 705px;\n            bottom: 612px;\n        }\n\n        #t1g_2 {\n            left: 76px;\n            bottom: 591px;\n        }\n\n        #t1h_2 {\n            left: 293px;\n            bottom: 591px;\n        }\n\n        #t1i_2 {\n            left: 500px;\n            bottom: 591px;\n        }\n\n        #t1j_2 {\n            left: 705px;\n            bottom: 591px;\n        }\n\n        #t1k_2 {\n            left: 76px;\n            bottom: 569px;\n        }\n\n        #t1l_2 {\n            left: 705px;\n            bottom: 571px;\n        }\n\n        #t1m_2 {\n            left: 46px;\n            bottom: 550px;\n            word-spacing: 5.6px;\n        }\n\n        #t1n_2 {\n            left: 67px;\n            bottom: 532px;\n            word-spacing: 0.6px;\n        }\n\n        #t1o_2 {\n            left: 67px;\n            bottom: 516px;\n        }\n\n        #t1p_2 {\n            left: 67px;\n            bottom: 498px;\n        }\n\n        #t1q_2 {\n            left: 67px;\n            bottom: 475px;\n        }\n\n        #t1r_2 {\n            left: 172px;\n            bottom: 470px;\n        }\n\n        #t1s_2 {\n            left: 194px;\n            bottom: 475px;\n        }\n\n        #t1t_2 {\n            left: 318px;\n            bottom: 475px;\n        }\n\n        #t1u_2 {\n            left: 398px;\n            bottom: 475px;\n        }\n\n        #t1v_2 {\n            left: 476px;\n            bottom: 475px;\n        }\n\n        #t1w_2 {\n            left: 560px;\n            bottom: 475px;\n        }\n\n        #t1x_2 {\n            left: 67px;\n            bottom: 454px;\n            letter-spacing: -0.5px;\n        }\n\n        #t1y_2 {\n            left: 67px;\n            bottom: 432px;\n        }\n\n        #t1z_2 {\n            left: 67px;\n            bottom: 411px;\n        }\n\n        #t20_2 {\n            left: 67px;\n            bottom: 388px;\n        }\n\n        #t21_2 {\n            left: 67px;\n            bottom: 368px;\n        }\n\n        #t22_2 {\n            left: 67px;\n            bottom: 346px;\n        }\n\n        #t23_2 {\n            left: 67px;\n            bottom: 325px;\n        }\n\n        #t24_2 {\n            left: 67px;\n            bottom: 303px;\n            letter-spacing: -0.2px;\n        }\n\n        #t25_2 {\n            left: 67px;\n            bottom: 280px;\n            letter-spacing: -0.3px;\n            word-spacing: 0.3px;\n        }\n\n        #t26_2 {\n            left: 67px;\n            bottom: 262px;\n            letter-spacing: -0.3px;\n        }\n\n        #t27_2 {\n            left: 372px;\n            bottom: 262px;\n        }\n\n        #t28_2 {\n            left: 46px;\n            bottom: 220px;\n        }\n\n        #t29_2 {\n            left: 67px;\n            bottom: 220px;\n            word-spacing: -0.1px;\n        }\n\n        #t2a_2 {\n            left: 67px;\n            bottom: 201px;\n            letter-spacing: -0.1px;\n            word-spacing: 0.1px;\n        }\n\n        #t2b_2 {\n            left: 415px;\n            bottom: 201px;\n            letter-spacing: -0.2px;\n            word-spacing: 0.2px;\n        }\n\n        #t2c_2 {\n            left: 67px;\n            bottom: 183px;\n        }\n\n        #t2d_2 {\n            left: 457px;\n            bottom: 183px;\n        }\n\n        #t2e_2 {\n            left: 67px;\n            bottom: 165px;\n            letter-spacing: -0.1px;\n            word-spacing: 0.1px;\n        }\n\n        #t2f_2 {\n            left: 67px;\n            bottom: 148px;\n            word-spacing: -2.7px;\n        }\n\n        #t2g_2 {\n            left: 140px;\n            bottom: 148px;\n            word-spacing: -0.3px;\n        }\n\n        #t2h_2 {\n            left: 46px;\n            bottom: 128px;\n        }\n\n        #t2i_2 {\n            left: 67px;\n            bottom: 128px;\n            letter-spacing: -0.2px;\n        }\n\n        #t2j_2 {\n            left: 392px;\n            bottom: 128px;\n        }\n\n        #t2k_2 {\n            left: 402px;\n            bottom: 128px;\n        }\n\n        #t2l_2 {\n            left: 67px;\n            bottom: 111px;\n        }\n\n        #t2m_2 {\n            left: 67px;\n            bottom: 82px;\n        }\n\n        #t2n_2 {\n            left: 146px;\n            bottom: 60px;\n        }\n\n        #t2o_2 {\n            left: 168px;\n            bottom: 60px;\n        }\n\n        #t2p_2 {\n            left: 187px;\n            bottom: 60px;\n        }\n\n        #t2q_2 {\n            left: 209px;\n            bottom: 60px;\n        }\n\n        #t2r_2 {\n            left: 233px;\n            bottom: 60px;\n            letter-spacing: -0.9px;\n        }\n\n        #t2s_2 {\n            left: 254px;\n            bottom: 60px;\n            letter-spacing: -0.9px;\n        }\n\n        #t2t_2 {\n            left: 274px;\n            bottom: 60px;\n            letter-spacing: -0.9px;\n        }\n\n        #t2u_2 {\n            left: 295px;\n            bottom: 60px;\n        }\n\n        #t2v_2 {\n            left: 67px;\n            bottom: 42px;\n        }\n\n        #t2w_2 {\n            left: 104px;\n            bottom: 42px;\n        }\n\n        .s1_2 {\n            FONT-SIZE: 42.8px;\n            FONT-FAMILY: ArialMT_zz;\n            color: rgb(35, 31, 32);\n        }\n\n        .s2_2 {\n            FONT-SIZE: 48.9px;\n            FONT-FAMILY: Arial-BoldMT_-1;\n            color: rgb(35, 31, 32);\n        }\n\n        .s3_2 {\n            FONT-SIZE: 48.9px;\n            FONT-FAMILY: ArialMT_zz;\n            color: rgb(35, 31, 32);\n        }\n\n        .s4_2 {\n            FONT-SIZE: 48.9px;\n            FONT-FAMILY: Arial-BoldMT_1i;\n            color: rgb(35, 31, 32);\n        }\n\n        .s5_2 {\n            FONT-SIZE: 85.6px;\n            FONT-FAMILY: Wingdings-Regular_-5;\n            color: rgb(35, 31, 32);\n        }\n\n        .s6_2 {\n            FONT-SIZE: 48.9px;\n            FONT-FAMILY: ArialMT_1j;\n            color: rgb(35, 31, 32);\n        }\n\n        .s7_2 {\n            FONT-SIZE: 48.9px;\n            FONT-FAMILY: Arial-BoldItalicMT_1h;\n            color: rgb(35, 31, 32);\n        }\n\n        .t.v0_2 {\n            -webkit-transform: scale(0.237, 0.25);\n            -ms-transform: scale(0.237, 0.25);\n            transform: scale(0.237, 0.25);\n        }\n\n        #form1_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 67px;\n            top: 373px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form2_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 672px;\n            top: 698px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form3_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 356px;\n            top: 399px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form4_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 509px;\n            top: 374px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form5_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 67px;\n            top: 397px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form6_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 451px;\n            top: 789px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form7_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 356px;\n            top: 374px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form8_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 695px;\n            top: 400px;\n            width: 23px;\n            height: 25px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form9_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 509px;\n            top: 399px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form10_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 535px;\n            top: 790px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form11_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 43px;\n            top: 651px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form12_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 184px;\n            top: 374px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form13_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 695px;\n            top: 376px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form14_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 373px;\n            top: 790px;\n            width: 25px;\n            height: 23px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form15_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 373px;\n            top: 219px;\n            width: 25px;\n            height: 25px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form16_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 292px;\n            top: 790px;\n            width: 25px;\n            height: 25px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form17_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 536px;\n            top: 219px;\n            width: 25px;\n            height: 25px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form18_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 694px;\n            top: 350px;\n            width: 25px;\n            height: 25px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form19_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 184px;\n            top: 399px;\n            width: 25px;\n            height: 25px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form20_2 {\n            z-index: 2;\n            border-style: none;\n            padding: 0px;\n            position: absolute;\n            left: 674px;\n            top: 674px;\n            width: 25px;\n            height: 25px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background-color: rgb(255, 255, 255);\n            font: normal 15px Wingdings, 'Zapf Dingbats';\n        }\n\n        #form21_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 133px;\n            top: 281px;\n            width: 63px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form22_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 376px;\n            top: 194px;\n            width: 151px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form23_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 220px;\n            top: 281px;\n            width: 150px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form24_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 371px;\n            top: 1025px;\n            width: 151px;\n            height: 20px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px 'Courier New', Courier, monospace;\n        }\n\n        #form25_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 184px;\n            top: 1070px;\n            width: 219px;\n            height: 15px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px Arial, Helvetica, sans-serif;\n        }\n\n        #form26_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 138px;\n            top: 1225px;\n            width: 171px;\n            height: 19px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px 'Courier New', Courier, monospace;\n        }\n\n        #form27_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 578px;\n            top: 1143px;\n            width: 228px;\n            height: 15px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px 'Times New Roman', Times, serif;\n        }\n\n        #form28_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 526px;\n            top: 1070px;\n            width: 240px;\n            height: 15px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px Arial, Helvetica, sans-serif;\n        }\n\n        #form29_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 203px;\n            top: 1089px;\n            width: 242px;\n            height: 15px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px Arial, Helvetica, sans-serif;\n        }\n\n        #form30_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 562px;\n            top: 196px;\n            width: 225px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form31_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 96px;\n            top: 1143px;\n            width: 289px;\n            height: 15px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px 'Times New Roman', Times, serif;\n        }\n\n        #form32_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 141px;\n            top: 1187px;\n            width: 240px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form33_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 74px;\n            top: 193px;\n            width: 248px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form34_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 356px;\n            top: 488px;\n            width: 257px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form35_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 393px;\n            top: 281px;\n            width: 280px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form36_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 194px;\n            top: 304px;\n            width: 333px;\n            height: 18px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 18px 'Times New Roman', Times, serif;\n        }\n\n        #form37_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 133px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form38_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 90px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form39_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 69px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form40_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 48px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form41_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 90px;\n            width: 539px;\n            height: 19px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px 'Courier New', Courier, monospace;\n        }\n\n        #form42_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 564px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form43_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 154px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form44_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 987px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form45_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 966px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form46_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 944px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form47_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 923px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form48_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 900px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form49_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 859px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form50_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 133px;\n            width: 539px;\n            height: 19px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px 'Courier New', Courier, monospace;\n        }\n\n        #form51_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 112px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form52_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 112px;\n            width: 539px;\n            height: 19px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px 'Courier New', Courier, monospace;\n        }\n\n        #form53_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 69px;\n            width: 539px;\n            height: 19px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px 'Courier New', Courier, monospace;\n        }\n\n        #form54_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 48px;\n            width: 539px;\n            height: 19px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px 'Courier New', Courier, monospace;\n        }\n\n        #form55_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 605px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form56_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 584px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form57_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 836px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form58_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 294px;\n            top: 814px;\n            width: 539px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n\n        #form59_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 69px;\n            top: 445px;\n            width: 648px;\n            height: 19px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 15px 'Courier New', Courier, monospace;\n        }\n\n        #form60_2 {\n            z-index: 2;\n            padding: 0px;\n            position: absolute;\n            left: 228px;\n            top: 526px;\n            width: 605px;\n            height: 21px;\n            color: rgb(0, 0, 0);\n            text-align: left;\n            background: transparent;\n            border: none;\n            font: normal 21px 'Times New Roman', Times, serif;\n        }\n    ",
              }}
            />
            {/* End inline CSS */}
            {/* Begin embedded font definitions */}
            <style
              id="fonts2"
              type="text/css"
              dangerouslySetInnerHTML={{
                __html:
                  '\n        @font-face {\n            font-family: Arial-BoldItalicMT_1h;\n            src: url("fonts/Arial-BoldItalicMT_1h.woff") format("woff");\n        }\n\n        @font-face {\n            font-family: Arial-BoldMT_-1;\n            src: url("fonts/Arial-BoldMT_-1.woff") format("woff");\n        }\n\n        @font-face {\n            font-family: Arial-BoldMT_1i;\n            src: url("fonts/Arial-BoldMT_1i.woff") format("woff");\n        }\n\n        @font-face {\n            font-family: ArialMT_1j;\n            src: url("fonts/ArialMT_1j.woff") format("woff");\n        }\n\n        @font-face {\n            font-family: ArialMT_zz;\n            src: url("fonts/ArialMT_zz.woff") format("woff");\n        }\n\n        @font-face {\n            font-family: Wingdings-Regular_-5;\n            src: url("fonts/Wingdings-Regular_-5.woff") format("woff");\n        }\n    ',
              }}
            />
            {/* End embedded font definitions */}
            {/* Begin page background */}
            {/*<div id="pg2Overlay" style="width:100%; height:100%; position:absolute; z-index:1; background-color:rgba(0,0,0,0); -webkit-user-select: none;"></div>*/}
            <img
              id="pg2"
              style={{ WebkitUserSelect: "none", width: 909, height: 1286 }}
              src="https://i.ibb.co/fksHk0C/page2.png"
            />
            {/* End page background */}
            <p id="lastone" className="lastone">
              Note : As per provisions of section 272B of the Income Tax Act,
              1961, a penality of Rs 10,000 can be levied on possession of more
              than one PAN
            </p>
            {/* Begin text definitions (Positioned/styled in CSS) */}
            <div id="t3_2" className="t s2_2">
              Ofﬁce Address{" "}
            </div>
            {/*<div id="t1_2" class="t s1_2">Signature / Left Thumb Impression of</div>*/}
            {/*<div id="t2_2" class="t s1_2">Applicant (inside the box)</div>*/}
            <div id="t111_2" className="t s1_2">
              {/* <img
                src=""
                id="sign-2"
                className="image-3"
                width="800px"
                height="200px"
                //  alt="photo"
              /> */}
            </div>
            <div id="t3_2" className="t s2_2">
              Ofﬁce Address{" "}
            </div>
            <div id="t4_2" className="t v0_2 s3_2">
              Name of ofﬁce
            </div>
            <div id="t5_2" className="t v0_2 s3_2">
              Flat / Room / Door / Block No.
            </div>
            <div id="t6_2" className="t v0_2 s3_2">
              Name of Premises / Building / Village
            </div>
            <div id="t7_2" className="t v0_2 s3_2">
              Road / Street / Lane/Post Ofﬁce{" "}
            </div>
            <div id="t8_2" className="t v0_2 s3_2">
              Area / Locality / Taluka/ Sub- Division
            </div>
            <div id="t9_2" className="t v0_2 s3_2">
              Town / City / District
            </div>
            <div id="ta_2" className="t s3_2">
              State / Union Territory{" "}
            </div>
            <div id="tb_2" className="t s3_2">
              Pincode / Zip code{" "}
            </div>
            <div id="tc_2" className="t s3_2">
              Country Name
            </div>
            <div id="td_2" className="t s4_2">
              8{" "}
            </div>
            <div id="te_2" className="t s4_2">
              Address for Communication
            </div>
            <div id="tf_2" className="t s4_2">
              Residence
            </div>
            <div id="tg_2" className="t s2_2">
              Ofﬁce{" "}
            </div>
            <div id="th_2" className="t s2_2">
              (Please tick as applicable)
            </div>
            <div id="ti_2" className="t s4_2">
              9{" "}
            </div>
            <div id="tj_2" className="t s4_2">
              Telephone Number &amp; Email ID details
            </div>
            <div id="tk_2" className="t s3_2">
              Country code{" "}
            </div>
            <div id="tl_2" className="t s3_2">
              Area/STD Code{" "}
            </div>
            <div id="tm_2" className="t s3_2">
              Telephone / Mobile number
            </div>
            <div id="tn_2" className="t s3_2">
              Email ID
            </div>
            <div id="to_2" className="t s4_2">
              10 Status of applicant
            </div>
            <div id="tp_2" className="t s3_2">
              Please select status,{" "}
            </div>
            <div id="tq_2" className="t s5_2">
              ✓
            </div>
            <div id="tr_2" className="t s3_2">
              as applicable
            </div>
            <div id="ts_2" className="t s3_2">
              Government
            </div>
            <div id="tt_2" className="t s6_2">
              Individual
            </div>
            <div id="tu_2" className="t s3_2">
              Hindu undivided family
            </div>
            <div id="tv_2" className="t s3_2">
              Company
            </div>
            <div id="tw_2" className="t s3_2">
              Partnership Firm
            </div>
            <div id="tx_2" className="t s3_2">
              Association of Persons
            </div>
            <div id="ty_2" className="t s3_2">
              Trusts
            </div>
            <div id="tz_2" className="t s3_2">
              Body of Individuals
            </div>
            <div id="t10_2" className="t s3_2">
              Local Authority
            </div>
            <div id="t11_2" className="t s3_2">
              Artiﬁcial Juridical Persons
            </div>
            <div id="t12_2" className="t s3_2">
              Limited Liability Partnership
            </div>
            <div id="t13_2" className="t s2_2">
              11 Registration Number (for company, ﬁrms, LLPs etc.)
            </div>
            <div id="t14_2" className="t s2_2">
              12{" "}
            </div>
            <div id="t15_2" className="t s2_2">
              In case of a person, who is required to quote Aadhaar number or
              the Enrolment ID of Aadhaar application form as per section 139 AA
            </div>
            <div id="t16_2" className="t s3_2">
              Please mention your AADHAAR number (if allotted){" "}
            </div>
            <div id="t17_2" className="t s3_2">
              If AADHAAR number is not allotted, please mention the enrolment ID
              of Aadhaar application form
            </div>
            <div id="t18_2" className="t s3_2">
              Name as per AADHAAR letter or card or as per the Enrolment ID of
              Aadhaar application form
            </div>
            <div id="t19_2" className="t s4_2">
              13
            </div>
            <div id="t1a_2" className="t s4_2">
              Source of Income
            </div>
            <div id="t1b_2" className="t s7_2">
              Please select,
            </div>
            <div id="t1c_2" className="t s5_2">
              ✓
            </div>
            <div id="t1d_2" className="t s7_2">
              as applicable
            </div>
            <div id="t1e_2" className="t s3_2">
              Salary
            </div>
            <div id="t1f_2" className="t s3_2">
              Capital Gains
            </div>
            <div id="t1g_2" className="t s3_2">
              Income from Business / Profession{" "}
            </div>
            <div id="t1h_2" className="t s3_2">
              Business/Profession code
            </div>
            <div id="t1i_2" className="t s3_2">
              [For Code: Refer instructions]
            </div>
            <div id="t1j_2" className="t s3_2">
              Income from Other sources
            </div>
            <div id="t1k_2" className="t s3_2">
              Income from House property{" "}
            </div>
            <div id="t1l_2" className="t s3_2">
              No income
            </div>
            <div id="t1m_2" className="t s2_2">
              14 Representative Assessee (RA)
            </div>
            <div id="t1n_2" className="t s3_2">
              Full name, address of the Representative Assessee, who is
              assessible under the Income Tax Act in respect of the person,
              whose particulars have{" "}
            </div>
            <div id="t1o_2" className="t s3_2">
              been given in the column 1-13.
            </div>
            <div id="t1p_2" className="t s2_2">
              Full Name (Full expanded name : initials are not permitted)
            </div>
            <div id="t1q_2" className="t s3_2">
              Please select title,
            </div>
            <div id="t1r_2" className="t s5_2">
              {" "}
              ✓
            </div>
            <div id="t1s_2" className="t s3_2">
              as applicable
            </div>
            <div id="t1t_2" className="t s3_2">
              Shri
            </div>
            <div id="t1u_2" className="t s3_2">
              Smt.
            </div>
            <div id="t1v_2" className="t s3_2">
              Kumari
            </div>
            <div id="t1w_2" className="t s3_2">
              M/s
            </div>
            <div id="t1x_2" className="t s3_2">
              Last Name / Surname
            </div>
            <div id="t1y_2" className="t s3_2">
              First Name
            </div>
            <div id="t1z_2" className="t s3_2">
              Middle Name
            </div>
            <div id="t20_2" className="t s4_2">
              Address
            </div>
            <div id="t21_2" className="t s3_2">
              Flat / Room / Door / Block No.
            </div>
            <div id="t22_2" className="t s3_2">
              Name of Premises / Building / Village
            </div>
            <div id="t23_2" className="t s3_2">
              Road / Street / Lane/Post Ofﬁce
            </div>
            <div id="t24_2" className="t s3_2">
              Area / Locality / Taluka/ Sub- Division
            </div>
            <div id="t25_2" className="t s3_2">
              Town / City / District
            </div>
            <div id="t26_2" className="t s3_2">
              State / Union Territory{" "}
            </div>
            <div id="t27_2" className="t s3_2">
              Pincode{" "}
            </div>
            <div id="t28_2" className="t s2_2">
              15{" "}
            </div>
            <div id="t29_2" className="t s2_2">
              Documents submitted as Proof of Identity (POI), Proof of Address
              (POA) and Proof of Date of Birth (POB){" "}
            </div>
            <div id="t2a_2" className="t s3_2">
              I/We have enclosed{" "}
            </div>
            <div id="t2b_2" className="t s3_2">
              as proof of identity,{" "}
            </div>
            <div id="t2c_2" className="t s3_2">
              as proof of address and{" "}
            </div>
            <div id="t2d_2" className="t s3_2">
              as proof of date of birth.
            </div>
            <div id="t2e_2" className="t v0_2 s3_2">
              [Please refer to the instructions (as speciﬁed in Rule 114 of I.T.
              Rules, 1962) for list of mandatory certiﬁed documents to be
              submitted as applicable]
            </div>
            <div id="t2f_2" className="t v0_2 s3_2">
              [Annexure A,{" "}
            </div>
            <div id="t2g_2" className="t v0_2 s3_2">
              Annexure B &amp; Annexure C are to be used wherever applicable]
            </div>
            <div id="t2h_2" className="t s4_2">
              16{" "}
            </div>
            <div id="t2i_2" className="t s3_2">
              I/We{" "}
            </div>
            <div id="t2j_2" className="t s3_2">
              ,{" "}
            </div>
            <div id="t2k_2" className="t s3_2">
              the applicant, in the capacity of{" "}
            </div>
            <div id="t2l_2" className="t s3_2">
              do hereby declare that what is stated above is true to the best of
              my/our information and belief.
            </div>
            <div id="t2m_2" className="t s3_2">
              Place :
            </div>
            <div id="t2n_2" className="t s3_2">
              D{" "}
            </div>
            <div id="t2o_2" className="t s3_2">
              D{" "}
            </div>
            <div id="t2p_2" className="t s6_2">
              M{" "}
            </div>
            <div id="t2q_2" className="t s6_2">
              M{" "}
            </div>
            <div id="t2r_2" className="t s6_2">
              Y{" "}
            </div>
            <div id="t2s_2" className="t s6_2">
              Y{" "}
            </div>
            <div id="t2t_2" className="t s6_2">
              Y{" "}
            </div>
            <div id="t2u_2" className="t s6_2">
              Y
            </div>
            <div id="t2v_2" className="t s3_2">
              Date{" "}
            </div>
            <div id="t2w_2" className="t s3_2">
              :{" "}
            </div>
            {/* End text definitions */}
            {/* Begin Form Data */}
            <input
              id="form1_2"
              type="checkbox"
              tabindex="60"
              data-objref="209 0 R"
              data-field-name="INDIVIDUAL"
              imageName="2/form/209 0 R"
              images="110100"
              checked="checked"
            />
            <input
              id="form2_2"
              type="checkbox"
              tabindex="74"
              data-objref="195 0 R"
              data-field-name="NOINCOME"
              imageName="2/form/195 0 R"
              images="110100"
              checked="checked"
            />
            <form>
              {/*/>
    
    <input id="form3_2" type="checkbox" tabindex="67" data-objref="202 0 R" data-field-name="Check Boxu" imageName="2/form/202 0 R" images="110100"/>
    <input id="form4_2" type="checkbox" tabindex="63" data-objref="206 0 R" data-field-name="Check Boxq" imageName="2/form/206 0 R" images="110100"/>
    <input id="form5_2" type="checkbox" tabindex="65" data-objref="204 0 R" data-field-name="Check Boxs" imageName="2/form/204 0 R" images="110100"/>
    <input id="form6_2" type="checkbox" tabindex="85" data-objref="181 0 R" data-field-name="MINORMINOR" imageName="2/form/181 0 R" images="110100"/>
    <input id="form7_2" type="checkbox" tabindex="62" data-objref="207 0 R" data-field-name="Check Boxp" imageName="2/form/207 0 R" images="110100"/>
    <input id="form8_2" type="checkbox" tabindex="69" data-objref="200 0 R" data-field-name="Check Boxw" imageName="2/form/200 0 R" images="110100"/>
    <input id="form9_2" type="checkbox" tabindex="68" data-objref="201 0 R" data-field-name="Check Boxv" imageName="2/form/201 0 R" images="110100"/>
    <input id="form10_2" type="checkbox" tabindex="77" data-objref="192 0 R" data-field-name="MINORNOTREQUIRED" imageName="2/form/192 0 R" images="110100"/>
    <input id="form11_2" type="checkbox" tabindex="73" data-objref="196 0 R" data-field-name="SELLARY" imageName="2/form/196 0 R" images="110100"/>
    <input id="form12_2" type="checkbox" tabindex="61" data-objref="208 0 R" data-field-name="Check Boxo" imageName="2/form/208 0 R" images="110100"/>
    <input id="form13_2" type="checkbox" tabindex="64" data-objref="205 0 R" data-field-name="Check Boxr" imageName="2/form/205 0 R" images="110100"/>
    <input id="form14_2" type="checkbox" tabindex="76" data-objref="193 0 R" data-field-name="MINORSMT" imageName="2/form/193 0 R" images="110100"/>
    input id="form15_2" type="checkbox" tabindex="56" data-objref="215 0 R" data-field-name="RESIDENCEADDRESS" imageName="2/form/215 0 R" images="110100" checked="checked"/>
    <input id="form16_2" type="checkbox" tabindex="75" data-objref="194 0 R" data-field-name="MINORSHRI" imageName="2/form/194 0 R" images="110100"/>
    <input id="form17_2" type="checkbox" tabindex="57" data-objref="214 0 R" data-field-name="OFFICEADDRESS" imageName="2/form/214 0 R" images="110100"/>
    <input id="form18_2" type="checkbox" tabindex="59" data-objref="210 0 R" data-field-name="Check Boxm" imageName="2/form/210 0 R" images="110100"/>
    <input id="form19_2" type="checkbox" tabindex="66" data-objref="203 0 R" data-field-name="Check Boxt" imageName="2/form/203 0 R" images="110100"/>
    <input id="form20_2" type="checkbox" tabindex="84" data-objref="182 0 R" data-field-name="INCOMEFROMOTHERSORCE" imageName="2/form/182 0 R" images="110100" checked="checked"/>
    <input id="form21_2" type="text" tabindex="78" maxlength="3" value="" data-objref="190 0 R" data-field-name="COUNTRYCODE"/>
    <input id="form22_2" type="text" tabindex="54" maxlength="7" value="" data-objref="160 0 R" data-field-name="OFFICE CODE"/>
    <input id="form23_2" type="text" tabindex="79" maxlength="7" value="" data-objref="188 0 R" data-field-name="AreaSTDCode"/>
    <input id="form24_2" type="text" tabindex="94" maxlength="7" value="" data-objref="224 0 R" title="15 Documents submitted as Proof of Identity (POI), Proof of Address (POA) and Proof of Date of Birth (POB" data-field-name="GUARDIAN AREAPINCODE"/>
    <input id="form25_2" type="text" tabindex="95" value="AADHAAR CARD" data-objref="223 0 R" title="as proof of address and" data-field-name="as proof of address and"/>
    <input id="form26_2" type="text" tabindex="101" maxlength="8" value="07052019" data-objref="216 0 R" title="D" data-field-name="APPCREATEDDATE"/>
    <input id="form27_2" type="text" tabindex="99" value="HERSELF" data-objref="218 0 R" title="the applicant, in the capacity of" data-field-name="the applicant in the capacity of"/>
    <input id="form28_2" type="text" tabindex="96" value="AADHAAR CARD" data-objref="221 0 R" title="as proof of date of birth" data-field-name="as proof of date of birth"/>
    <input id="form29_2" type="text" tabindex="97" value="AADHAAR CARD" data-objref="220 0 R" title="Please refer to the instructions (as specified in Rule 114 of I.T. Rules, 1962) for list of mandatory certified documents to be submitted as applicable" data-field-name="Please refer to the instructions as specified in Rule 114 of IT Rules 1962 for list of mandatory certified documents to be submitted as applicable"/>
    <input id="form30_2" type="text" tabindex="55" maxlength="25" value="" data-objref="159 0 R" data-field-name="OFFICE Country Name"/>
    <input id="form31_2" type="text" tabindex="98" value="NEELAVVA TEGGI" data-objref="219 0 R" title="do hereby declare that what is stated above is true to the best of my/our information and belief" data-field-name="do hereby declare that what is stated above is true to the best of myour information and belief"/>
    <input id="form32_2" type="text" tabindex="100" value="GANGAVATHI" data-objref="217 0 R" title="D" data-field-name="D"/>
    <input id="form33_2" type="text" tabindex="53" maxlength="25" value="" data-objref="162 0 R" title="Country Name" data-field-name="OFFICE STATE"/>
    <input id="form34_2" type="text" tabindex="82" maxlength="12" value="855271028993" data-objref="185 0 R" title="If AADHAAR number is not allotted, please mention the enrolment ID of Aadhaar application form" data-field-name="If AADHAAR number is not allotted please mention the enrolment ID of Aadhaar application form"/>
    <input id="form35_2" type="text" tabindex="80" maxlength="13" value="" data-objref="187 0 R" title="Telephone / Mobile number" data-field-name="TelephoneMobilenumber"/>
    <input id="form36_2" type="text" tabindex="58" value="" data-objref="213 0 R" title="email" data-field-name="email"/>*/}
              <input
                id="form37_2"
                type="text"
                tabIndex={106}
                maxLength={25}
                defaultValue=""
                data-objref="1389 0 R"
                data-field-name="OFFICE TALLUK"
              />
              <input
                id="form38_2"
                type="text"
                tabIndex={104}
                maxLength={25}
                defaultValue=""
                data-objref="1387 0 R"
                title="Name of Premises / Building / Village"
                data-field-name="OFFICE VILLAGE"
              />
              <input
                id="form39_2"
                type="text"
                tabIndex={103}
                maxLength={25}
                defaultValue=""
                data-objref="1386 0 R"
                data-field-name="OFFICE FLATROOMDOOR"
              />
              <input
                id="form40_2"
                type="text"
                tabIndex={102}
                maxLength={25}
                defaultValue=""
                data-objref="1385 0 R"
                data-field-name="NAMEOFOFFICE"
              />
              <input
                id="form41_2"
                type="text"
                tabIndex={49}
                maxLength={25}
                defaultValue=""
                data-objref="169 0 R"
                title="Name of Premises / Building / Village"
                data-field-name="OFFICE VILLAGE"
              />
              <input
                id="form42_2"
                type="text"
                tabIndex={70}
                maxLength={25}
                defaultValue=""
                data-objref="199 0 R"
                data-field-name="NAMEASPERAADHAAR"
              />
              <input
                id="form43_2"
                type="text"
                tabIndex={52}
                maxLength={25}
                defaultValue=""
                data-objref="163 0 R"
                data-field-name="OFFICE DIST"
              />
              <input
                id="form44_2"
                type="text"
                tabIndex={93}
                maxLength={25}
                defaultValue=""
                data-objref="225 0 R"
                title="Pincode"
                data-field-name="GUARDIAN Pincode"
              />
              <input
                id="form45_2"
                type="text"
                tabIndex={92}
                maxLength={25}
                defaultValue=""
                data-objref="227 0 R"
                title="Area / Locality / Taluka/ Sub- Division"
                data-field-name="GUARDIAN Area  Locality  Taluka Sub Division_3"
              />
              <input
                id="form46_2"
                type="text"
                tabIndex={91}
                maxLength={25}
                defaultValue=""
                data-objref="229 0 R"
                data-field-name="GUARDIANPOSTOFFICE"
              />
              <input
                id="form47_2"
                type="text"
                tabIndex={90}
                maxLength={25}
                defaultValue=""
                data-objref="231 0 R"
                data-field-name="GUARDIAN Name of Premises"
              />
              <input
                id="form48_2"
                type="text"
                tabIndex={89}
                maxLength={25}
                defaultValue=""
                data-objref="175 0 R"
                title="undefined"
                data-field-name="GUARDIANROOMDORBLOCK"
              />
              <input
                id="form49_2"
                type="text"
                tabIndex={88}
                maxLength={25}
                defaultValue=""
                data-objref="176 0 R"
                data-field-name="GUARDIANMIDDLENAME"
              />
              <input
                id="form50_2"
                type="text"
                tabIndex={51}
                maxLength={25}
                defaultValue=""
                data-objref="165 0 R"
                data-field-name="OFFICE TALLUK"
              />
              <input
                id="form51_2"
                type="text"
                tabIndex={105}
                maxLength={25}
                defaultValue=""
                data-objref="1388 0 R"
                data-field-name="OFFICE POST"
              />
              <input
                id="form52_2"
                type="text"
                tabIndex={50}
                maxLength={25}
                defaultValue=""
                data-objref="167 0 R"
                data-field-name="OFFICE POST"
              />
              <input
                id="form53_2"
                type="text"
                tabIndex={48}
                maxLength={25}
                defaultValue=""
                data-objref="171 0 R"
                data-field-name="OFFICE FLATROOMDOOR"
              />
              <input
                id="form54_2"
                type="text"
                tabIndex={47}
                maxLength={25}
                defaultValue=""
                data-objref="173 0 R"
                data-field-name="NAMEOFOFFICE"
              />
              <input
                id="form55_2"
                type="text"
                tabIndex={72}
                maxLength={25}
                defaultValue=""
                data-objref="197 0 R"
                data-field-name="NAMEESPERAADHAAR 3"
              />
              <input
                id="form56_2"
                type="text"
                tabIndex={71}
                maxLength={25}
                defaultValue=""
                data-objref="198 0 R"
                data-field-name="NAMEASPERAADHAAR2"
              />
              <input
                id="form57_2"
                type="text"
                tabIndex={87}
                maxLength={25}
                defaultValue=""
                data-objref="178 0 R"
                title="undefined"
                data-field-name="GUARDIANFIRSTNAME"
              />
              <input
                id="form58_2"
                type="text"
                tabIndex={86}
                maxLength={25}
                defaultValue=""
                data-objref="180 0 R"
                title="undefined"
                data-field-name="GUARDIAN"
              />
              <input
                id="form59_2"
                type="text"
                tabIndex={81}
                maxLength={30}
                defaultValue=""
                data-objref="186 0 R"
                title="11 Registration Number (for company, firms, LLPs etc"
                data-field-name="11 Registration Number for company firms LLPs etc"
              />
              <input
                id="form60_2"
                type="text"
                tabIndex={83}
                maxLength={28}
                defaultValue=""
                data-objref="183 0 R"
                title="Name as per AADHAAR letter or card or as per the Enrolment ID of Aadhaar application form"
                data-field-name="Name as per AADHAAR letter or card or as per the Enrolment ID of Aadhaar application form"
              />
            </form>
            <div id="custom_align1">
              {/*Address for Communication*/}

              <label
                className="checkbox-container"
                style={{ left: 373, bottom: 1053 }}
              >
                <input type="checkbox" checked={true} />
                <span className="checkmark" />
              </label>

              {/* <label
                className="checkbox-container"
                style={{ left: 536, bottom: 1053 }}
              >
                <input type="checkbox" checked={true} />
                <span className="checkmark" />
              </label> */}

              <div
                id="contact_address1"
                data-selectedvalue="R"
                className="t little-input contact_address"
                style={{ left: 377, bottom: 1047, fontSize: 65 }}
              />
              <div
                id="contact_address2"
                data-selectedvalue="O"
                className="t little-input contact_address"
                style={{ left: 542, bottom: 1047, fontSize: 65 }}
              />
              {/*Status of applicant*/}
              <div
                id="applicant_type3"
                data-selectedvalue="C"
                className="t little-input applicant_type"
                style={{ left: 359, bottom: 892, fontSize: 65 }}
              />
              <div
                id="applicant_type4"
                data-selectedvalue="P"
                className="t little-input applicant_type"
                style={{ left: 510, bottom: 892, fontSize: 65 }}
              />
              <div
                id="applicant_type5"
                data-selectedvalue="G"
                className="t little-input applicant_type"
                style={{ left: 696, bottom: 914, fontSize: 65 }}
              />
              <div
                id="applicant_type6"
                data-selectedvalue="A"
                className="t little-input applicant_type"
                style={{ left: 696, bottom: 892, fontSize: 65 }}
              />
              <div
                id="applicant_type7"
                data-selectedvalue="T"
                className="t little-input applicant_type"
                style={{ left: 70, bottom: 867, fontSize: 65 }}
              />
              <div
                id="applicant_type8"
                data-selectedvalue="B"
                className="t little-input applicant_type"
                style={{ left: 185, bottom: 867, fontSize: 65 }}
              />
              <div
                id="applicant_type9"
                data-selectedvalue="L"
                className="t little-input applicant_type"
                style={{ left: 359, bottom: 867, fontSize: 65 }}
              />
              <div
                id="applicant_type10"
                data-selectedvalue="AJ"
                className="t little-input applicant_type"
                style={{ left: 510, bottom: 867, fontSize: 65 }}
              />
              <div
                id="applicant_type11"
                data-selectedvalue="LL"
                className="t little-input applicant_type"
                style={{ left: 696, bottom: 867, fontSize: 65 }}
              />
              {/*Source of Income*/}
              <div
                id="income_type1"
                data-selectedvalue="S"
                className="t little-input income_type"
                style={{ left: 50, bottom: 614, fontSize: 65 }}
              />
              <div
                id="income_type2"
                data-selectedvalue="B"
                className="t little-input income_type"
                style={{ left: 50, bottom: 593, fontSize: 65 }}
              />
              <div
                id="income_type3"
                data-selectedvalue="H"
                className="t little-input income_type"
                style={{ left: 50, bottom: 571, fontSize: 65 }}
              />
              <div
                id="income_type4"
                data-selectedvalue="G"
                className="t little-input income_type"
                style={{ left: 678, bottom: 614, fontSize: 65 }}
              />
              <input
                type="text"
                className="t little-input profession_code"
                style={{ left: 462, bottom: 593 }}
              />
              <input
                type="text"
                className="t little-input profession_code"
                style={{ left: 483, bottom: 593 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 310, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 330, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 352, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 375, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 394, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 419, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 441, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 464, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 486, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 507, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 529, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 551, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 572, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 594, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 615, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 637, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 659, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 681, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 702, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 724, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 745, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 767, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 789, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 810, bottom: 1219 }}
              />
              <input
                type="text"
                className="t little-input off_name"
                style={{ left: 830, bottom: 1219 }}
              />
              {/* Flat / Room / Door / Block No.*/}
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 310, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 330, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 352, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 375, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 394, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 419, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 441, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 464, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 486, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 507, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 529, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 551, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 572, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 594, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 615, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 637, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 659, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 681, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 702, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 724, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 745, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 767, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 789, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 810, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_door_no"
                style={{ left: 830, bottom: 1197 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 310, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 330, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 352, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 375, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 394, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 419, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 441, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 464, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 486, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 507, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 529, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 551, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 572, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 594, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 615, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 637, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 659, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 681, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 702, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 724, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 745, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 767, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 789, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 810, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_building_name"
                style={{ left: 830, bottom: 1177 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 310, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 330, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 352, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 375, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 394, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 419, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 441, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 464, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 486, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 507, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 529, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 551, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 572, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 594, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 615, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 637, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 659, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 681, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 702, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 724, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 745, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 767, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 789, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 810, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_road_name"
                style={{ left: 830, bottom: 1156 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 310, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 330, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 352, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 375, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 394, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 419, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 441, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 464, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 486, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 507, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 529, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 551, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 572, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 594, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 615, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 637, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 659, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 681, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 702, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 724, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 745, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 767, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 789, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 810, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_area_name"
                style={{ left: 830, bottom: 1134 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 310, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 330, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 352, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 375, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 394, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 419, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 441, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 464, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 486, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 507, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 529, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 551, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 572, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 594, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 615, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 637, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 659, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 681, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 702, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 724, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 745, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 767, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 789, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 810, bottom: 1114 }}
              />
              <input
                type="text"
                className="t little-input off_town_name"
                style={{ left: 830, bottom: 1114 }}
              />
              {/*State / Union Territory*/}
              <input
                type="text"
                className="t little-input off_state_name"
                style={{ left: 73, bottom: 1072, width: 1172 }}
              />
              <input
                type="text"
                className="t little-input off_pincode"
                style={{ left: 392, bottom: 1072 }}
              />
              <input
                type="text"
                className="t little-input off_pincode"
                style={{ left: 414, bottom: 1072 }}
              />
              <input
                type="text"
                className="t little-input off_pincode"
                style={{ left: 436, bottom: 1072 }}
              />
              <input
                type="text"
                className="t little-input off_pincode"
                style={{ left: 458, bottom: 1072 }}
              />
              <input
                type="text"
                className="t little-input off_pincode"
                style={{ left: 481, bottom: 1072 }}
              />
              <input
                type="text"
                className="t little-input off_pincode"
                style={{ left: 502, bottom: 1072 }}
              />
              <input
                type="text"
                className="t little-input off_pincode"
                style={{ left: 525, bottom: 1072 }}
              />
              <input
                type="text"
                className="t little-input off_country"
                style={{ left: 510, bottom: 1072, width: 1172 }}
              />
              <input
                type="text"
                className="t little-input country_code"
                style={{ left: 152, bottom: 984 }}
                defaultValue=""
              />
              <input
                type="text"
                className="t little-input country_code"
                style={{ left: 172, bottom: 984 }}
                defaultValue={9}
              />
              <input
                type="text"
                className="t little-input country_code"
                style={{ left: 196, bottom: 984 }}
                defaultValue={1}
              />
              <input
                type="text"
                className="t little-input area_code"
                style={{ left: 238, bottom: 984 }}
              />
              <input
                type="text"
                className="t little-input area_code"
                style={{ left: 260, bottom: 984 }}
              />
              <input
                type="text"
                className="t little-input area_code"
                style={{ left: 282, bottom: 984 }}
              />
              <input
                type="text"
                className="t little-input area_code"
                style={{ left: 303, bottom: 984 }}
              />
              <input
                type="text"
                className="t little-input area_code"
                style={{ left: 325, bottom: 984 }}
              />
              <input
                type="text"
                className="t little-input area_code"
                style={{ left: 347, bottom: 984 }}
              />
              <input
                type="text"
                className="t little-input area_code"
                style={{ left: 368, bottom: 984 }}
              />

              {panData.telNo?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="mobile_no"
                    className="t little-input mobile_no"
                    style={{ left: `${412 + index * 22}px`, bottom: 984 }}
                    defaultValue={value}
                  />
                </div>
              ))}

              <input
                type="text"
                className="t little-input email_id"
                style={{ left: 96, bottom: 963, width: 1311 }}
                defaultValue={panData.emailId}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 88, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 107, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 128, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 151, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 172, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 195, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 215, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 236, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 258, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 281, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 303, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 323, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 345, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 367, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 387, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 410, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 432, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 455, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 475, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 498, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 518, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 539, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 562, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 584, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 606, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 627, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 649, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 669, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 692, bottom: 823 }}
              />
              <input
                type="text"
                className="t little-input registration_no"
                style={{ left: 713, bottom: 823 }}
              />

              {panData.aadhaarNo?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="aadhaar_no"
                    className="t little-input aadhaar_no"
                    style={{ left: `${373 + index * 22}px`, bottom: 777 }}
                    defaultValue={value}
                  />
                </div>
              ))}

              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 247, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 269, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 289, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 310, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 330, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 352, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 375, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 394, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 419, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 441, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 464, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 486, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 507, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 529, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 551, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 572, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 594, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 615, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 637, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 659, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 681, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 702, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 724, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 745, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 767, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 789, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 810, bottom: 742 }}
              />
              <input
                type="text"
                className="t little-input enrollment_id"
                style={{ left: 830, bottom: 742 }}
              />

              {panData.panName?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="aadhaar_card_name"
                    className="t little-input aadhaar_card_name"
                    style={{ left: `${310 + index * 22}px`, bottom: 704 }}
                    defaultValue={value}
                  />
                </div>
              ))}

              {panData.repLast?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="rep_last_name"
                    className="t little-input rep_last_name"
                    style={{ left: `${310 + index * 22}px`, bottom: 451 }}
                    defaultValue={value}
                  />
                </div>
              ))}

              {panData.repFirst?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="rep_first_name"
                    className="t little-input rep_first_name"
                    style={{ left: `${310 + index * 22}px`, bottom: 430 }}
                    defaultValue={value}
                  />
                </div>
              ))}

              {panData.repMiddle?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="rep_middle_name"
                    className="t little-input rep_middle_name"
                    style={{ left: `${310 + index * 22}px`, bottom: 409 }}
                    defaultValue={value}
                  />
                </div>
              ))}

              {/*Flat / Room / Door / Block No*/}
              {panData.repAddr1?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="rep_door_no"
                    className="t little-input rep_door_no"
                    style={{ left: `${310 + index * 22}px`, bottom: 366 }}
                    defaultValue={value}
                  />
                </div>
              ))}

              {panData.repAddr2?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="rep_building_name"
                    className="t little-input rep_building_name"
                    style={{ left: `${295 + index * 22}px`, bottom: 344 }}
                    defaultValue={value}
                  />
                </div>
              ))}

              {panData.repAddr3?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="rep_road_name"
                    className="t little-input rep_road_name"
                    style={{ left: `${295 + index * 22}px`, bottom: 322 }}
                    defaultValue={value}
                  />
                </div>
              ))}

              {panData.repAddr4?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="rep_area_name"
                    className="t little-input rep_area_name"
                    style={{ left: `${295 + index * 22}px`, bottom: 301 }}
                    defaultValue={value}
                  />
                </div>
              ))}

              {panData.repDist?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="rep_town_name"
                    className="t little-input rep_town_name"
                    style={{ left: `${295 + index * 22}px`, bottom: 279 }}
                    defaultValue={value}
                  />
                </div>
              ))}

              <input
                type="text"
                className="t little-input rep_state_name"
                style={{ left: 76, bottom: 241, width: 1172 }}
                defaultValue={panData.state}
              />

              {panData.repPin?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="rep_pincode"
                    className="t little-input rep_pincode"
                    style={{ left: `${392 + index * 22}px`, bottom: 241 }}
                    defaultValue={value}
                  />
                </div>
              ))}

              <input
                type="text"
                className="t little-input proof_of_identity"
                style={{ left: 198, bottom: 200, width: 896 }}
                defaultValue={"AADHAAR CARD ISSUED BY UIDAI"}
              />
              <input
                type="text"
                className="t little-input proof_of_address"
                style={{ left: 512, bottom: 200, width: 1172 }}
                defaultValue={"AADHAAR CARD ISSUED BY UIDAI"}
              />
              <input
                type="text"
                className="t little-input enclosed_id"
                style={{ left: 186, bottom: 180, width: 1172 }}
                defaultValue={"AADHAAR CARD ISSUED BY UIDAI"}
              />
              <input
                type="text"
                className="t little-input declaration_name"
                style={{ left: 76, bottom: 127, width: 1172 }}
                defaultValue={panData.panName}
              />
              <input
                type="text"
                className="t little-input capacity_of"
                style={{ left: 558, bottom: 128, width: 1172 }}
                defaultValue="HIMSELF/HERSELF"
              />
              <input
                type="text"
                className="t little-input dec_place"
                style={{
                  left: 100,
                  bottom: 80,
                  width: 942,
                  fontSize: 60,
                  textAlign: "center",
                }}
                defaultValue={panData.resDist}
              />

              {panData.date?.split("").map((value, index) => (
                <div key={index}>
                  <input
                    type="text"
                    id="dec_date"
                    className="t little-input dec_date"
                    style={{ left: `${155 + index * 22}px`, bottom: 40 }}
                    defaultValue={value}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PANForm;
